/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  // Space,
  Tooltip,
  Typography,
  // DatePicker,
  Switch,
  AutoComplete,
  Select,
  Radio,
  Upload,
  Image,
  Skeleton,
} from "antd";
import qrCodeLogo from "../../assets/images/barcode-placeholder.svg";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  SettingOutlined,
  PlusOutlined,
  CloseCircleOutlined,
  PlusCircleFilled,
  // DownOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  DownOutlined,
  SearchOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { PiBarcodeBold } from "react-icons/pi";
import { isEmpty, isUndefined } from "lodash";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { BiCalendar, BiQrScan } from "react-icons/bi";
import axios from "axios";
import CreateItems from "../Items/items";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import {
  // createPartyVendorAddress,
  // createPurchaseList,
  loadPartyVendorAddress,
  loadPurchaseImportRamList,
  loadPurchaseInvoice,
} from "../../store/purchase-invoice/actions";
import { loadPurchaseRecordsMetaData } from "../../store/purchase-orders/actions";
import {
  createVendorList,
  loadVendor,
  updateVendorList,
} from "../../store/vendor/actions";
import {
  createCategoryList,
  loadCategory,
  loadGradeList,
  loadItems,
} from "../../store/items/actions";
import "react-datepicker/dist/react-datepicker.css";
import {
  loadFinancialYearList,
  loadPrefixSettingsList,
} from "../../store/expenses/actions";
import api from "../../helpers";
import useMedia from "use-media-antd-query";
// import Spinners from "../../components/spinner/Spinner";

const CreatePurchaseInvoice = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const media = useMedia();

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  //initial loading states
  // const [additionalOptions, setAdditionalOptions] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [partyMode, setPartyMode] = useState("");
  const [autoRoundOffMethod, setAutoRoundOffMethod] = useState([]);
  const [poDate, setPoDate] = useState("");
  const [poNo, setPoNo] = useState("");
  const [paymentTerms, setPaymentTerms] = useState("");
  const [gradeList, setGradeList] = useState([]);
  const [gradeListValue, setGradeListValue] = useState("");
  const [prefixValue, setPrefixValue] = useState("");
  const [validDate, setValidDate] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // const [initialLoading, setInitialLoading] = useState(false);
  const [isVendorButtonDisabled, setIsVendorButtonDisabled] = useState(false);
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const organizationName = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationName
    : "";

  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const purchaseList = { organizationId: organizationId };

  const updatedData =
    props.location && props.location.state
      ? props.location.state.purchaseInvoiceData
      : "";

  //Initial load
  const poDateValue = moment().format("YYYY-MM-DD");
  const validDateValue = moment().add(1, "month").format("YYYY-MM-DD");

  const paymentTermsOnly = moment(validDateValue).diff(poDateValue, "days");

  useEffect(() => {
    // setInitialLoading(true);
    // setTimeout(() => {
    //   setInitialLoading(false);
    // }, 2500);
    setDiscount({
      value: "Display After Tax",
      label: "Display After Tax",
    });
    setAutoRoundOffMethod([]);
    setPoDate(poDateValue);
    setValidDate(validDateValue);
    setPaymentTerms(paymentTermsOnly + 1);
    dispatch(
      loadGradeList({
        organizationId: organizationId,
      })
    );
    dispatch(loadFinancialYearList());
    dispatch(loadPrefixSettingsList(purchasePrefixList));
    dispatch(loadPurchaseImportRamList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePoDateChange = (date) => {
    const poDateValues = moment(date).format("YYYY-MM-DD");
    const validDateValues = moment(validDate).format("YYYY-MM-DD");

    setPoDate(date);
    const paymentTermsOnly = moment(validDateValues).diff(poDateValues, "days");
    setPaymentTerms(paymentTermsOnly + 1);
  };
  const handleValidDateChange = (date) => {
    const poDateValues = moment(poDate).format("YYYY-MM-DD");
    const validDateValues = moment(date).format("YYYY-MM-DD");

    setValidDate(date);
    const paymentTermsOnly = moment(validDateValues).diff(poDateValues, "days");
    setPaymentTerms(paymentTermsOnly + 1);
  };

  //reducer state
  const { vendor_list = [] } = useSelector((state) => state.Vendor);
  const { financial_year_list = [], prefix_settings_list } = useSelector(
    (state) => state.Expenses
  );
  const { party_address_list = [], import_ram_list = [] } = useSelector(
    (state) => state.PurchaseInvoice
  );
  const { recordsMetaData = {} } = useSelector((state) => state.PurchaseOrders);

  //Reducer state
  const {
    items_list = [],
    category_list = [],
    grade_list = [],
    // recordsMetaData = {},
  } = useSelector((state) => state.Items);

  const categoryOptions =
    category_list.length > 0
      ? category_list.map((c) => {
          return {
            label: c.categoryName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];

  const gradeListOptions =
    grade_list && grade_list.length > 0
      ? grade_list.map((data) => {
          return { label: data.gradeName, value: data._id };
        })
      : [];
  const ramListOptions =
    import_ram_list && import_ram_list.length > 0
      ? import_ram_list.map((data) => {
          return { label: data.ramName, value: data._id };
        })
      : [];

  const financialyearId =
    financial_year_list && financial_year_list.length > 0
      ? financial_year_list[0]._id
      : "";

  //create party modal states
  const [piId, setPiId] = useState("");
  const [vendorName, setVendorName] = useState("");
  const [addressValidations, setAddressValidations] = useState(false);
  const [partyAddressData, setPartyAddressData] = useState([
    {
      address1: "",
      city: "",
      country: "",
      pincode: "",
      state: "",
      stateName: "",
      _id: "",
    },
  ]);

  const [partyModalData, setPartyModalData] = useState({
    mobile: "",
    vendorName: "",
    cityName: "",
    gstIn: "",
    billingAddress: "",
    totalAddress: "",
    state: "",
    billingCityName: "",
    billingAddressValue: "",
    totalBillingAddress: "",
    billingState: "",
    vendorId: "",
    _id: "",
  });

  const handleModalChange = (e) => {
    setPartyModalData({
      ...partyModalData,
      [e.target.name]: e.target.value,
    });
  };

  const [newShippingData, setNewShippingData] = useState({
    cityName: "",
    billingAddress: "",
    totalAddress: "",
    state: "",
    _id: "",
  });

  const handleShippingModalChange = (e) => {
    setNewShippingData({
      ...newShippingData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (party_address_list && party_address_list.length > 0) {
      setPartyAddressData(party_address_list);
    }
  }, [party_address_list]);

  //party vendor state modal section
  const [partyCheckedId, setPartyCheckedId] = useState("");
  const [sameAs, setSameAs] = useState("");
  const [stateData, setStateData] = useState([]);
  const [pincode, setPincode] = useState("");
  const [shippingState, setShippingState] = useState([]);
  const [shippingPincode, setShippingPincode] = useState("");
  const [billingStateData, setBillingStateData] = useState([]);
  const [billingPincode, setBillingPincode] = useState("");
  const [partyModal, setPartyModal] = useState(false);
  const [createPartyModal, setCreatePartyModal] = useState(false);
  const [createShippingModal, setCreateShippingModal] = useState(false);
  const [createNewShippingModal, setCreateNewShippingModal] = useState(false);
  const [addAddressShow, setAddAddressShow] = useState(false);
  const [addGstShow, setAddGstShow] = useState(false);

  //Billing modal
  const billingAddressSubmit = () => {
    if (
      isEmpty(newShippingData.billingAddress) &&
      shippingState &&
      shippingPincode
    ) {
      toast.error(
        `${
          isEmpty(newShippingData.billingAddress) &&
          (isEmpty(shippingState) || isEmpty(shippingPincode))
            ? "The street address field,"
            : ""
        } ${
          isEmpty(shippingState) && isEmpty(shippingPincode)
            ? "State field,"
            : isEmpty(shippingState) && !isEmpty(shippingPincode)
            ? "state field"
            : ""
        } ${isEmpty(shippingPincode) ? "pincode field" : ""} is required`
      );
    } else {
      const partyAddress = {
        organizationId: organizationId,
        partyOrVendorId: partyModalData._id,
        shippingAddress: {
          address1: newShippingData.billingAddress,
          // "address2": "Near SVR",
          country: "India",
          state: !isEmpty(newShippingData.state)
            ? newShippingData.state
            : shippingState,
          pincode: shippingPincode,
          city: newShippingData.cityName,
        },
      };

      // dispatch(createPartyVendorAddress(partyAddress));
      api
        .post("/org/addpartyorvendorshippingaddress", partyAddress)
        .then((res) => {
          setTimeout(() => {
            dispatch(
              loadPartyVendorAddress({
                organizationId: organizationId,
                partyorvendorId: partyModalData._id,
              })
            );
            toast.success("Shipping address added successfully");
            setCreateNewShippingModal(false);
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error;
          toast.error(errorMsg || "There is an issue while update the address");
          Promise.reject(error);
        });
    }
  };

  const billingAddressUpdate = () => {
    if (
      isEmpty(newShippingData.billingAddress) &&
      shippingState &&
      shippingPincode
    ) {
      toast.error(
        `${
          isEmpty(newShippingData.billingAddress) &&
          (isEmpty(shippingState) || isEmpty(shippingPincode))
            ? "The street address field,"
            : ""
        } ${
          isEmpty(shippingState) && isEmpty(shippingPincode)
            ? "State field,"
            : isEmpty(shippingState) && !isEmpty(shippingPincode)
            ? "state field"
            : ""
        } ${isEmpty(shippingPincode) ? "pincode field" : ""} is required`
      );
    } else {
      const partyAddress = {
        organizationId: organizationId,
        partyOrVendorId: partyModalData._id,
        shippingAddressId: newShippingData._id,
        shippingAddress: {
          address1: newShippingData.billingAddress,
          // "address2": "Near SVR",
          country: "India",
          state: !isEmpty(newShippingData.state)
            ? newShippingData.state
            : shippingState,
          pincode: shippingPincode,
          city: newShippingData.cityName,
        },
      };
      api
        .put("/org/updatepartyorvendorshippingaddress", partyAddress)
        .then((res) => {
          setTimeout(() => {
            dispatch(
              loadPartyVendorAddress({
                organizationId: organizationId,
                partyorvendorId: partyModalData._id,
              })
            );
            toast.success("Shipping address updated successfully");
            setCreateNewShippingModal(false);
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.error;
          toast.error(errorMsg || "There is an issue while update the address");
          Promise.reject(error);
        });
      // dispatch(createPartyVendorAddress(partyAddress));
    }
  };

  //parties rows
  const [vendorRows, setVendorRows] = useState([
    {
      vendorName: "",
      mobileNo: "",
      vendorNameValue: "",
      partyCode: "",
      billingAddress: [],
      shippingAddress: [],
      openingbalanceType: "",
      _id: "",
      state: "",
      currentBalance: "",
      status: "",
    },
  ]);

  const vendorDataTable =
    vendor_list && vendor_list.length > 0
      ? vendor_list.map((data, index) => {
          return {
            index: index + 1,
            billingAddress: data.billingAddress,
            shippingAddress: data.shippingAddress,
            _id: data._id,
            creditBalance: data.creditBalance,
            currentBalance: data.currentBalance,
            mobileNo: data.mobileNo,
            openingbalanceType: data.openingbalanceType,
            vendorName: data.vendorName ? data.vendorName : "--",
            creditLimit: data.creditLimit ? data.creditLimit : "--",
            displayName: data.displayName ? data.displayName : "--",
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (vendorDataTable && vendorDataTable.length > 0) {
      setVendorRows(vendorDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendor_list]);

  //data table
  const [search, setSearch] = useState("");
  const [tableLoading, setTableLoading] = useState(false);

  const handleSearch = (event) => {
    const filteredRows = vendorDataTable
      .filter((row) =>
        row.vendorName.toLowerCase().includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setVendorRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const purchasePartyData = {
    organizationId: organizationId,
    vendorName: partyModalData.vendorName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddress,
        // address2: "Suite 456",
        country: "India",
        state: stateData,
        pincode: pincode,
        city: partyModalData.cityName,
      },
    ],
    shippingAddress:
      sameAs === true
        ? [
            {
              address1: partyModalData.billingAddressValue,
              // address2: "Suite 456",
              country: "India",
              state: billingStateData,
              pincode: billingPincode,
              city: partyModalData.billingCityName,
            },
          ]
        : [
            {
              address1: partyModalData.billingAddress,
              // address2: "Suite 456",
              country: "India",
              state: stateData,
              pincode: pincode,
              city: partyModalData.cityName,
            },
          ],
    createdBy: userId,
  };

  const purchasePartyObj = Object.keys(purchasePartyData).forEach(
    (k) => !purchasePartyData[k] && delete purchasePartyData[k]
  );
  const purchaseUpdatePartyData = {
    vendorId: partyModalData._id,
    organizationId: organizationId,
    vendorName: partyModalData.vendorName,
    mobileNo: partyModalData.mobile ? partyModalData.mobile : "",

    placeofSupply: partyModalData.cityName ? partyModalData.cityName : "",

    billingAddress: [
      {
        address1: partyModalData.billingAddressValue,
        // address2: "Suite 456",
        country: "India",
        state: billingStateData,
        pincode: billingPincode,
        city: partyModalData.billingCityName,
      },
    ],
    shippingAddress:
      sameAs === true
        ? [
            {
              address1: partyModalData.billingAddress,
              // address2: "Suite 456",
              country: "India",
              state: !isEmpty(partyModalData.state)
                ? partyModalData.state
                : stateData,
              pincode: pincode,
              city: partyModalData.cityName,
            },
          ]
        : [
            {
              address1: partyModalData.billingAddressValue,
              // address2: "Suite 456",
              country: "India",
              state: billingStateData,
              pincode: billingPincode,
              city: partyModalData.billingCityName,
            },
          ],
    createdBy: userId,
  };

  const purchaseUpdatePartyObj = Object.keys(purchaseUpdatePartyData).forEach(
    (k) => !purchaseUpdatePartyData[k] && delete purchaseUpdatePartyData[k]
  );

  console.log(purchasePartyObj, "purchasePartyObj");
  console.log(purchaseUpdatePartyObj, "purchaseUpdatePartyObj");

  //create items list
  const createVendorApi = () => {
    setAddAddressShow(true);
    if (
      !isEmpty(partyModalData.vendorName) &&
      !isEmpty(partyModalData.billingAddress) &&
      !isEmpty(stateData) &&
      !isEmpty(pincode)
    ) {
      setIsVendorButtonDisabled(true);
      setTimeout(() => {
        setIsVendorButtonDisabled(false);
      }, 6000);
      dispatch(createVendorList(purchasePartyData));

      setTimeout(() => {
        dispatch(loadVendor(purchaseList));
        toast.success("Vendor Added Successfully");
        setCreatePartyModal(false);
        setAddressValidations(false);
      }, 2000);
    } else {
      setAddressValidations(true);
    }
  };
  //create items list
  const updateVendorApi = () => {
    setAddAddressShow(true);
    if (
      !isEmpty(partyModalData.vendorName) &&
      !isEmpty(partyModalData.billingAddress) &&
      !isEmpty(stateData) &&
      !isEmpty(pincode)
    ) {
      setIsVendorButtonDisabled(true);
      setTimeout(() => {
        setIsVendorButtonDisabled(false);
      }, 6000);
      dispatch(updateVendorList(purchaseUpdatePartyData));

      setTimeout(() => {
        dispatch(loadVendor(purchaseList));
        toast.success("Vendor Updated Successfully");
        setCreatePartyModal(false);
      }, 2000);
    } else {
      setAddressValidations(true);
    }
  };

  //purchase State values
  const [columnSettings, setColumnSettings] = useState(false);
  const [notesOpen, setNotesOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  const [additionalChargesOpen, setAdditionalChargesOpen] = useState(false);
  const [discountOpen, setDiscountOpen] = useState(false);
  const [autoRoundOff, setAutoRoundOff] = useState(false);

  const [purchaseData, setPurchaseData] = useState({
    price: true,
    sellingPrice: true,
    quantity: true,
    travel: true,
    batch: true,
    expiryDate: true,
    mfgDate: false,
  });
  const [notes, setNotes] = useState("");
  const [termsConditions, setTermsConditions] = useState("");

  const [totalSectionData, setTotalSectionData] = useState({
    chargesData: "",
    additionalCharges: "",
    discountPercent: "",
    discountAmount: "",
    autoRoundOffValue: "",
    amountPaid: "",
    totalAmount: "",
    tcsTaxName: "",
    tcsSectionName: "",
    tcsRatePercent: "",
    tdsTaxName: "",
    tdsSectionName: "",
    tdsRatePercent: "",
    chargeId: "",
  });

  const handlePurchaseChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      // mobileNumber: /^[0-9]*$/, // Only numeric characters allowed
      discountPercent: /^[0-9]\d*\.?\d*$/,
      discountAmount: /^\d*\.?\d*$/,
      autoRoundOffValue: /^\d*\.?\d*$/,
      totalAmount: /^\d*\.?\d*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setTotalSectionData({
          ...totalSectionData,
          [name]: value,
        });
      }
    } else {
      setTotalSectionData({
        ...totalSectionData,
        [name]: value,
      });
    }

    if (name === "discountPercent") {
      const discountPercentageValue = totals.totalAmount
        ? parseInt((totals.totalAmount * value) / 100)
        : 0;
      setTotalSectionData({
        ...totalSectionData,
        [name]: value,
        discountAmount: discountPercentageValue,
      });
    }
    if (name === "discountAmount") {
      const discountAmountValue = totals.totalAmount
        ? parseInt((100 * value) / totals.totalAmount)
        : 0;

      setTotalSectionData({
        ...totalSectionData,
        [name]: value,
        discountPercent: discountAmountValue,
      });
    }
  };

  // const handleDiscountChange = (e) => {
  //   const listData = totalSectionData;
  //   listData.discountPercent = parseInt(e.target.value * 100);

  //   setTotalSectionData(listData);
  // };

  //Item create modal
  const [itemModal, setItemModal] = useState(false);
  // const [purchaseItemSelect, setPurchaseItemSelect] = useState(false);
  const [createItemModal, setCreateItemModal] = useState(false);
  const [scanQrModal, setScanQrModal] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  // const [expandable, setExpandable] = useState(false);
  const [quantityShow, setQuantityShow] = useState(false);
  // const [quantityCount, setQuantityCount] = useState(false);
  // const [quantityCountValue, setQuantityCountValue] = useState(0);
  // const [quantityCountId, setQuantityCountId] = useState("");
  const [pageRender, setPageRender] = useState(false);
  const [purchasePriceModal, setPurchasePriceModal] = useState(false);
  const [purchaseColumn, setPurchaseColumn] = useState(false);
  // const [asOfDate, setAsOfDate] = useState("");
  // const [batchingModal, setBatchingModal] = useState(false);

  //create category modal
  const [categoryName, setCategoryName] = useState("");
  const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");
  const [description, setDescription] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [renderPage, setRenderPage] = useState(false);

  const handleClose = (data) => {
    setCreateItemModal(data);
  };

  const [itemRows, setItemRows] = useState([
    {
      itemName: "",
      ramId: "",
      ramName: "",
      itemChecked: "",
      itemNameValue: "",
      itemDescription: "",
      itemCode: "",
      salesPrice: "",
      purchasePrice: "",
      discountPrice: "",
      discountPercentage: "",
      taxPercentageValue: "",
      taxValue: "",
      totalAmount: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      quantityCount: 0,
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      taxPercentageId: "",
      taxPercentageName: "",
      image: "",
      isProduct: "",
      hsnCode: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      serialMeasuringId: "",
      updatedAt: "",
      itemUpdateId: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const [itemSelectedRows, setItemSelectedRows] = useState([
    {
      itemName: "",
      itemChecked: "",
      itemNameValue: "",
      taxPercentageValue: "",
      itemDescription: "",
      itemCode: "",
      ramId: "",
      ramName: "",
      salesPrice: "",
      purchasePrice: "",
      discountPrice: "",
      discountPercentage: "",
      taxPercentage: "",
      taxValue: "",
      taxPercentageId: "",
      taxPercentageName: "",
      totalAmount: "",
      hsnCode: "",
      categoryId: "",
      categoryName: "",
      stockQTY: "",
      quantityCount: "",
      batchDetails: "",
      createdAt: "",
      createdBy: "",
      customFields: "",
      image: "",
      isProduct: "",
      isService: "",
      measuringId: "",
      serialDetails: "",
      itemUpdateId: "",
      serialMeasuringId: "",
      updatedAt: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const itemsDataTable =
    items_list && items_list.length > 0
      ? items_list.map((data, index) => {
          const categoryName =
            categoryOptions && categoryOptions.length > 0
              ? categoryOptions.find(
                  (category) => category.value === data.categoryId
                )
              : "";

          const categoryNameValue = !isEmpty(categoryName)
            ? categoryName.label
            : "";
          const gstPercentage =
            data.gstPercentageName &&
            data.gstPercentageName.replace(/^%|%$/g, "");
          return {
            index: index + 1,
            itemName: data.itemName,
            itemNameValue: data.itemName,
            itemChecked: "",
            taxPercentageValue: gstPercentage,
            _id: data._id,
            itemCode: data.itemCode ? data.itemCode : "--",
            salesPrice: data.salesPrice ? data.salesPrice : "",
            purchasePrice: data.purchasePrice
              ? parseFloat(data.purchasePrice).toFixed(2)
              : "",
            stockQTY: data.noofStock ? data.noofStock : "--",
            quantityCount: 0,
            batchDetails: data.batchDetails,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            customFields: data.customFields,
            categoryId: data.categoryId,
            itemUpdateId: "",
            categoryName: data.categoryName,
            categoryNameValue: categoryNameValue,
            // taxPercentageId: "66f68f17cf8942d1531c55f4",
            // taxPercentageId: data.gstPercentageId,
            // taxPercentageName: "0%",
            taxPercentageId:
              data.gstPercentageId !== null ||
              data.gstPercentageId !== undefined
                ? data.gstPercentageId
                : "66f68f17cf8942d1531c55f4",
            taxPercentageName:
              data.gstPercentageName !== null ||
              data.gstPercentageName !== undefined
                ? data.gstPercentageName
                : "0%",
            serialMeasuringId: data.serialMeasuringId,
            serialMeasuringName: data.serialMeasuringName,
            image: data.image,
            itemCodeValue: data.itemCode,
            salesPriceValue: data.salesPrice,
            purchasePriceValue: data.purchasePrice,
            stockQTYValue: data.noofStock,
            categoryIdValue: data.categoryId,
            hsnCode: data.hsnCode,
            descriptionValue: data.description,
            isProduct: data.isProduct,
            isService: data.isService,
            measuringId: data.measuringId,
            description: data.description,
            serialDetails: data.serialDetails,
            updatedAt: data.updatedAt,
            ramId: "",
            ramName: "",
            status: data.status,
          };
        })
      : [];

  useEffect(() => {
    if (itemsDataTable && itemsDataTable.length > 0) {
      setItemRows(itemsDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items_list]);

  //handle item rows change
  const handleItemChange = (e, name, index, data) => {
    const itemList = itemRows;
    if (name == "itemChecked") {
      itemList[index][name] = e.target.checked;
      setItemRows(itemList);
      setRenderPage(!renderPage);

      const selectedIndex = itemSelectedRows.indexOf(data);
      let newSelecteds = [];
      if (e.target.checked === true) {
        if (selectedIndex === -1) {
          newSelecteds = newSelecteds.concat(itemSelectedRows, data);
        }
      } else {
        newSelecteds = newSelecteds.concat(itemSelectedRows.slice(0, -1));
      }

      const itemSelectedFilteredRows =
        newSelecteds && newSelecteds.length > 0
          ? newSelecteds.filter((data) => !isEmpty(data.itemName))
          : [];

      const itemSelectedArrays =
        newSelecteds &&
        itemSelectedFilteredRows &&
        itemSelectedFilteredRows.length > 0
          ? itemSelectedFilteredRows.map((data, index) => {
              // const gstPercentage = data.taxPercentageName.replace(
              //   /^%|%$/g,
              //   ""
              // );
              const totalPriceData =
                !isUndefined(data.quantityCount) && data.salesPrice
                  ? data.quantityCount * data.salesPrice
                  : isUndefined(data.quantityCount) && data.salesPrice
                  ? data.salesPrice
                  : 0;
              const totalSetAmountData =
                (totalPriceData * data.taxPercentageValue) / 100;
              const totalPrice = totalSetAmountData + totalPriceData;

              return {
                index: index + 1,
                itemName: data.itemName,
                itemNameValue: data.itemName,
                itemChecked: true,
                _id: data._id,
                itemCode: data.itemCode ? data.itemCode : "--",
                salesPrice: data.salesPrice ? data.salesPrice : "",
                purchasePrice: data.purchasePrice ? data.purchasePrice : "",
                stockQTY: data.noofStock ? data.noofStock : "--",
                batchDetails: data.batchDetails,
                createdAt: data.createdAt,
                createdBy: data.createdBy,
                ramId: data.ramId,
                ramName: data.ramName,
                customFields: data.customFields,
                categoryId: data.categoryId,
                categoryName: data.categoryName,
                categoryNameValue: data.categoryName,
                taxPercentageId: data.taxPercentageId,
                taxPercentageName: data.taxPercentageName,
                taxPercentageValue: data.taxPercentageValue,
                serialMeasuringId: data.serialMeasuringId,
                serialMeasuringName: data.serialMeasuringName,
                image: data.image,
                itemCodeValue: data.itemCode,
                salesPriceValue: data.salesPrice,
                purchasePriceValue: data.purchasePrice,
                discountPrice: !isUndefined(data.discountPrice)
                  ? data.discountPrice
                  : 0,
                discountPercentage: !isUndefined(data.discountPercentage)
                  ? data.discountPercentage
                  : 0,
                taxPercentage: data.taxPercentage,
                taxValue: totalSetAmountData,
                totalAmount: totalPrice,
                quantityCount: data.quantityCount ? data.quantityCount : "",
                categoryIdValue: data.categoryId,
                hsnCode: data.hsnCode,
                descriptionValue: data.description,
                isProduct: data.isProduct,
                isService: data.isService,
                measuringId: data.measuringId,
                description: data.description,
                serialDetails: data.serialDetails,
                updatedAt: data.updatedAt,
                status: data.status,
              };
            })
          : [];

      setItemSelectedRows(itemSelectedArrays);
    }
  };

  const removeItemsData = (index) => {
    const array = [...itemSelectedRows];
    array.splice(index, 1); // Remove the row at the specified index
    setItemSelectedRows(array);
    // const array = itemSelectedRows;
    // if (index !== 0) {
    //   if (index > -1) {
    //     array.splice(index, 1);
    //   }
    // }
    setPageRender(!pageRender);
  };

  //item Selected on change
  const itemSelectedChange = (e, name, index) => {
    var itemList = itemSelectedRows;
    if (name == "itemDescription") {
      e = e.target.value;
      itemList[index][name] = e;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "salesPrice") {
      e = e.target.value;
      itemList[index][name] = e;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "ramId") {
      const ramId = e && ramListOptions.find((data) => data.value === e);

      const ram = ramId && ramId.label && ramId.label;

      itemList[index]["ramId"] = e;
      itemList[index]["ramName"] = ram;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "taxPercentageId") {
      const gstPercentageId =
        e &&
        recordsMetaData &&
        recordsMetaData.gstPercentageOptions.find((data) => data.value === e);

      const gstPercentage =
        gstPercentageId.label == "None" || gstPercentageId.label == "Exempted"
          ? 0
          : gstPercentageId.label.replace(/^%|%$/g, "");

      const totalAmount =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePrice
          ? itemList[index].quantityCount * itemList[index].purchasePrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const totalSetAmountData = parseFloat(totalAmount * gstPercentage) / 100;
      const totalSetAmount = totalSetAmountData + totalAmount;
      const totalSetAmountTotal =
        totalSetAmount - itemList[index].discountPrice;
      itemList[index]["taxPercentageId"] = e;
      itemList[index]["taxPercentageName"] = gstPercentage;
      itemList[index]["taxValue"] = totalSetAmountData;
      itemList[index]["totalAmount"] =
        parseFloat(totalSetAmountTotal).toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "purchasePrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) && e
          ? itemList[index].quantityCount * e
          : isUndefined(itemList[index].quantityCount) && e
          ? e
          : isEmpty(e) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPrice = itemList[index].discountPrice
        ? parseFloat(itemList[index].discountPrice)
        : 0;
      const discountPercentage = itemList[index].discountPercentage
        ? parseFloat(itemList[index].discountPercentage)
        : 0;

      const totalAmountPrice =
        itemList[index].discountPrice &&
        parseFloat(itemList[index].discountPrice) > 0
          ? parseFloat(totalAmountData - discountPrice)
          : parseFloat(totalAmountData);
      console.log(itemList[index].taxPercentageValue, "taxPercentageValue");
      const totalSetAmountData = itemList[index].taxPercentageValue
        ? parseFloat(
            (itemList[index].taxPercentageValue * totalAmountData) / 100
          )
        : parseFloat(
            (itemList[index].taxPercentageName * totalAmountData) / 100
          );
      const taxPercentageIdValue = itemList[index].taxPercentageId;
      const taxPercentageNameValue = itemList[index].taxPercentageName;
      console.log(totalSetAmountData, "totalSetAmountData");
      const totalAmountDetails = totalSetAmountData
        ? totalAmountPrice + totalSetAmountData
        : totalAmountPrice;
      console.log(totalAmountDetails, "totalAmountDetails");
      itemList[index][name] = e && parseFloat(e).toFixed(2);
      // itemList[index]["purchasePrice"] = totalAmountData;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["taxPercentageId"] = taxPercentageIdValue;
      itemList[index]["taxPercentageNameValue"] = taxPercentageNameValue;
      itemList[index]["totalAmount"] =
        parseFloat(totalAmountDetails).toFixed(2);
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "quantityCount") {
      e = e.target.value;
      const totalAmountData =
        e && itemList[index].purchasePrice
          ? e * itemList[index].purchasePrice
          : isEmpty(e) && itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) && e
          ? e
          : 0;
      // const totalSetAmountData = parseInt(itemList[index].taxPercentageValue);
      const totalSetAmountData =
        (parseInt(itemList[index].taxPercentageValue) * totalAmountData) / 100;

      const totalAmountDetails = totalSetAmountData
        ? totalAmountData + totalSetAmountData
        : totalAmountData;

      const salesPrice = itemList[index].salesPrice;
      itemList[index][name] = e;
      itemList[index]["salesPrice"] = salesPrice;
      itemList[index]["totalAmount"] =
        parseFloat(totalAmountDetails).toFixed(2);
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPercentage") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePrice
          ? itemList[index].quantityCount * itemList[index].purchasePrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPrice = (e * totalAmountData) / 100;
      const totalAmountTax = parseFloat(
        totalAmountData + itemList[index].taxValue
      );
      const totalAmount = itemList[index].taxValue
        ? totalAmountTax - discountPrice
        : totalAmountData - discountPrice;
      itemList[index][name] = e;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["totalAmount"] = parseFloat(totalAmount).toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePrice
          ? itemList[index].quantityCount * itemList[index].purchasePrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;
      const discountPercentage = (e * 100) / itemList[index].totalAmount;

      const discountPrice =
        e !== "" ? parseFloat(totalAmountData - e) : totalAmountData;
      // const discountPriceValue = parseInt(itemList[index].discountPrice);

      const taxValue = itemList[index].taxPercentageValue
        ? parseFloat(itemList[index].taxPercentageValue)
        : parseFloat(itemList[index].taxPercentageName);
      const taxValueFinal =
        e > 0
          ? parseFloat(discountPrice * taxValue) / 100
          : parseFloat(totalAmountData * taxValue) / 100;
      // const totalAmount = e > 0 ? discountPrice : totalAmountData;

      const discountTaxValue =
        e > 0
          ? parseFloat(taxValueFinal + discountPrice)
          : parseFloat(totalAmountData + taxValueFinal);

      itemList[index][name] = e;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["totalAmount"] = parseFloat(discountTaxValue).toFixed(2);
      itemList[index]["taxValue"] =
        e == 0 || !isEmpty(e) ? parseFloat(itemList[index].taxValue) : "";
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "totalAmount") {
      e = e.target.value;
      itemList[index][name] = e && parseFloat(e).toFixed(2);
      // itemList[index][name] = e
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
  };

  console.log(itemSelectedRows, "itemSelectedRows");

  const [itemSearch, setItemSearch] = useState("");
  const [itemCategoryModal, setItemCategoryModal] = useState(false);

  const handleItemSearch = (event) => {
    const filteredRows = itemsDataTable
      .filter((row) =>
        row.itemNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates
    // .filter((item) =>

    //   item.toLowerCase().includes(search.toLowerCase()) // Case-insensitive match
    // )
    setItemSearch(event.target.value);
    setItemRows(filteredRows);
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let salesPrice = 0;
    let purchasePrice = 0;
    let discountPrice = 0;
    let totalAmount = 0;
    let taxValue = 0;

    rows.forEach((row) => {
      salesPrice += parseFloat(row.salesPrice) || 0;
      purchasePrice += parseFloat(row.purchasePrice) || 0;
      discountPrice += parseFloat(row.discountPrice) || 0;
      totalAmount += parseFloat(row.totalAmount) || 0;
      taxValue +=
        row.taxValue ||
        // ? parseFloat(row.taxValue * row.quantityCount)
        // : parseFloat(row.taxValue)
        0;
    });

    return { salesPrice, purchasePrice, discountPrice, totalAmount, taxValue };
  };

  const [totals, setTotals] = React.useState({
    salesPrice: 0,
    purchasePrice: 0,
    discountPrice: 0,
    totalAmount: 0,
    taxValue: 0,
  });

  const taxData =
    itemSelectedRows.length > 0 &&
    itemSelectedRows[0].itemName &&
    itemSelectedRows.reduce((acc, item) => {
      // const taxValueList =
      //   item.taxPercentageName && item.taxPercentageName.charAt(item.taxPercentageName - 1);
      const taxValue =
        item.taxPercentageName && item.taxPercentageName.replace("%", "");
      const taxValueArray = taxValue && taxValue;

      item.taxPercentageName = taxValueArray;

      if (!acc[item.taxPercentageName]) {
        acc[item.taxPercentageName] = { count: 0, totalSum: 0 };
      }
      acc[item.taxPercentageName].count += 1;
      acc[item.taxPercentageName].totalSum += item.taxValue;
      return acc;
    }, {});

  // Common taxes (appear more than once) with their total sum
  const commonTaxes = Object.keys(taxData)
    .filter((tax) => taxData[tax].count > 1)
    .map((tax) => {
      return {
        tax: Number(tax),
        totalSum: taxData[tax].totalSum,
      };
      // totalSum: parseFloat(taxData[tax].totalSum).toFixed(2),
    });

  // Unique taxes (appear only once)
  const uniqueTaxes = Object.keys(taxData)
    .filter((tax) => taxData[tax].count === 1)
    .map((tax) => {
      return {
        tax: Number(tax),
        totalSum: taxData[tax].totalSum,
        // totalSum: parseFloat(taxData[tax].totalSum).toFixed(2),
      };
    });
  console.log(commonTaxes, "commonTaxes");
  console.log(uniqueTaxes, "uniqueTaxes");
  console.log(taxData, "taxData");

  useEffect(() => {
    // if(itemSelected === true) {

    const newTotals = calculateTotals(itemSelectedRows);
    setTotals(newTotals);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemSelectedRows, renderPage]);

  const [isCategoryButtonDisabled, setIsCategoryButtonDisabled] =
    useState(false);
  const [categoryValidations, setCategoryValidations] = useState(false);
  //category api integrations
  const createCategory = () => {
    if (!isEmpty(categoryName)) {
      setIsCategoryButtonDisabled(true);
      setTimeout(() => {
        setIsCategoryButtonDisabled(false);
      }, 6000);
      const categoryList = {
        categoryName: categoryName,
        organizationId: organizationId,
        shortCode: shortCode,
        description: description,
        createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
      };

      dispatch(createCategoryList(categoryList));
      setTimeout(() => {
        dispatch(loadCategory(purchaseList));
        setItemCategoryModal(false);
        toast.success("Category Created Successfully");
      }, 1000);
    } else {
      setCategoryValidations(true);
      // simpleValidator.current.showMessages();
      // forceUpdate(1);
    }
  };

  //Serialisation
  const [serialOpenStock, setSerialOpenStock] = useState("");
  const [serialData, setSerialData] = useState([
    {
      serialNo: "",
    },
  ]);

  const addSerialData = () => {
    setSerialData([
      ...serialData,
      {
        serialNo: "",
      },
    ]);
    // setSerialDataAdd(true);
    setPageRender(!pageRender);
  };

  const removeSerialData = (index) => {
    const array = serialData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
        setSerialOpenStock(array.length);
      }
    }
    setPageRender(!pageRender);
  };

  const handleSerialDataChange = (e, name, index) => {
    var fieldList = serialData;
    if (name === "serialNo") {
      fieldList[index][name] = e.target.value;
      setSerialData(fieldList);

      // if (fieldList.length > 0 && !isEmpty(fieldList[0].serialNo)) {
      setSerialOpenStock(fieldList.length);
      // }
      setPageRender(!pageRender);
    }
  };

  //tds & tcs

  const [pageRouting, setPageRouting] = useState(false);

  //settings States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const purchasePrefixList = {
    organizationId: organizationId,
    isType: "isPurchase",
  };
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [purchaseSettings, setPurchaseSettings] = useState({
    prefix: "",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPurchaseSettings({
      ...purchaseSettings,
      [e.target.name]: e.target.value,
    });
  };

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //Image upload
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      // reader.onerror = (error) => reject(error);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [updatePreviewImage, setUpdatePreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) => {
    var fileArrayDetails =
      newFileList && newFileList.length > 0 ? newFileList[0].originFileObj : "";
    // var teamUploadValue = fileList;
    var formData = new FormData();
    formData.append("file", fileArrayDetails);

    setTimeout(() => {
      api
        .post(`/img/upload`, formData)
        .then(async (res) => {
          if (res && res.data) {
            // teamUploadValue.push(res.data);
            // toast.success("Image Uploaded successfully");
            await setFileList([res.data.file]);
          }
        })
        .catch((error) => {
          toast.error(
            `${
              !isEmpty(error) && error.response && error.response.data
                ? error.response.data.error
                : ""
            }`
          );
        });
    }, 1000);
  };

  //upload btn
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Add Signature
      </div>
    </button>
  );

  const roundOffFinalValues = totalSectionData.autoRoundOffValue
    ? parseFloat(totalSectionData.autoRoundOffValue)
    : "";
  const additionalChargesFinalValues = totalSectionData.additionalCharges
    ? parseFloat(totalSectionData.additionalCharges)
    : "";
  const dicountAmountValues = totalSectionData.discountAmount
    ? parseFloat(totalSectionData.discountAmount)
    : "";
  // console.log(autoRoundOffMethod,)
  //Po net amount
  const discountFinalAmount =
    autoRoundOffMethod.value == "reduce" &&
    (additionalChargesFinalValues == "" ||
      totalSectionData.additionalCharges == null)
      ? parseFloat(totals.totalAmount - roundOffFinalValues)
      : autoRoundOffMethod.value == "reduce" &&
        (additionalChargesFinalValues !== "" ||
          additionalChargesFinalValues !== null)
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues -
            roundOffFinalValues
        )
      : additionalChargesFinalValues == ""
      ? parseFloat(totals.totalAmount + roundOffFinalValues)
      : autoRoundOffMethod.value == "add" &&
        additionalChargesFinalValues !== "" &&
        roundOffFinalValues !== ""
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues +
            roundOffFinalValues
        )
      : autoRoundOffMethod.value == "add" &&
        (additionalChargesFinalValues === "" ||
          additionalChargesFinalValues === null) &&
        (roundOffFinalValues === "" || roundOffFinalValues === null)
      ? parseFloat(totals.totalAmount)
      : autoRoundOffMethod.value == "add" &&
        (additionalChargesFinalValues !== "" ||
          additionalChargesFinalValues !== null) &&
        (roundOffFinalValues === "" || roundOffFinalValues === null)
      ? parseFloat(totals.totalAmount + additionalChargesFinalValues)
      : autoRoundOffMethod.value == "add" &&
        (additionalChargesFinalValues === "" ||
          additionalChargesFinalValues === null) &&
        (roundOffFinalValues !== "" || roundOffFinalValues !== null)
      ? parseFloat(totals.totalAmount + roundOffFinalValues)
      : parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues +
            roundOffFinalValues
        );
  const roundOffFinalWithTotal =
    autoRoundOffMethod.value == "reduce"
      ? parseInt(totals.totalAmount - roundOffFinalValues)
      : parseInt(totals.totalAmount + roundOffFinalValues);
  console.log(discountFinalAmount, "discountFinalAmount");

  console.log(totalSectionData, "totalSectionData");
  const netAmount =
    itemSelectedRows &&
    itemSelectedRows.length > 0 &&
    (totalSectionData.additionalCharges == "" ||
      totalSectionData.additionalCharges == null) &&
    (totalSectionData.autoRoundOffValue == "" ||
      totalSectionData.autoRoundOffValue == null) &&
    (totalSectionData.discountAmount == "" ||
      totalSectionData.discountAmount == null)
      ? totals.totalAmount
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges == "" &&
        totalSectionData.autoRoundOffValue == "" &&
        totalSectionData.discountAmount != ""
      ? parseFloat(discountFinalAmount - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges !== "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount !== ""
      ? parseFloat(discountFinalAmount - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges == "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount !== ""
      ? parseInt(roundOffFinalWithTotal - totalSectionData.discountAmount)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges !== "" &&
        totalSectionData.autoRoundOffValue !== "" &&
        totalSectionData.discountAmount == ""
      ? discountFinalAmount
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? roundOffFinalWithTotal
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        totalSectionData.discountAmount !== ""
      ? parseFloat(
          totals.totalAmount +
            additionalChargesFinalValues -
            dicountAmountValues
        )
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? parseFloat(totals.totalAmount + additionalChargesFinalValues)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges &&
        !isEmpty(updatedData) &&
        isEmpty(totalSectionData.autoRoundOffValue) &&
        isEmpty(totalSectionData.discountAmount)
      ? parseInt(totals.totalAmount + totalSectionData.additionalCharges)
      : itemSelectedRows.length > 0 &&
        isEmpty(totalSectionData.additionalCharges) &&
        !isEmpty(totalSectionData.autoRoundOffValue) &&
        !isEmpty(totalSectionData.discountAmount)
      ? parseInt(roundOffFinalWithTotal - dicountAmountValues)
      : 0;

  //Po add api payloads
  const purchaseInvoiceListData = {
    vendorId: partyModalData._id,
    organizationId: organizationId,
    purchaseinvoiceNo: poNo,
    purchaseinvoiceDate: poDate,
    orginvoiceNo: !isEmpty(prefixValue) ? prefixValue : "",
    dueDate: validDate,
    financialyearId: financialyearId,
    isType: !isEmpty(prefixValue) ? "isPurchase" : "",
    paymentTerms: paymentTerms,
    // vendorName: partyModalData.vendorName,
    vendorAddress: [
      {
        address1: partyModalData.billingAddress,
        city: partyModalData.cityName,
        state: partyModalData.state ? partyModalData.state : stateData,
        country: "India",
        pincode: pincode,
      },
    ],
    vendorPhone: partyModalData.mobile,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            return {
              itemId: data._id,
              gradeId: !isEmpty(gradeListValue) ? gradeListValue : gradeList,
              qty: data.quantityCount,
              ramId: data.ramId,
              sellingprice: data.salesPrice,
              purchaseprice: data.purchasePrice,
              discount: data.discountPrice,
              discountPercentage:
                data.discountPercentage && parseFloat(data.discountPercentage),
              taxId: data.taxPercentageId,
              tax:
                data.taxValue !== null || !isEmpty(data.taxValue)
                  ? data.taxValue
                  : 0,
              totalAmount: data.totalAmount,
              // totalAmount: data.totalAmount,
            };
          })
        : [],
    subtotalamount:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.totalAmount : 0,
    subtotaldiscount:
      itemSelectedRows && itemSelectedRows.length > 0
        ? totals.discountPrice
        : 0,
    // totaltaxableValue:
    //   itemSelectedRows && itemSelectedRows.length > 0 ? totals.salesPrice : 0,
    subtotaltax:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.taxValue : 0,
    charges: [
      {
        chargeName: totalSectionData.chargesData,
        chargeAmount: totalSectionData.additionalCharges,
        // gstPercentage: 18,
        // gstAmount: 18,
        // amountInclofTax: 118,
      },
    ],
    // taxableAmonut: totals.salesPrice,
    beforeTax: discount === "Display Before Tax" ? true : false,
    discountPercentage: totalSectionData.discountPercent,
    discountAmount: totalSectionData.discountAmount,
    autoroundoff: autoRoundOff === true ? true : false,
    isautoroundoffadd:
      autoRoundOff === true && autoRoundOffMethod.value == "add" ? true : false,
    isautoroundoffreduce:
      autoRoundOff === true && autoRoundOffMethod.value == "reduce"
        ? true
        : false,
    // autoroundoff: autoRoundOff === true ? true : false,
    autoroundoffamount:
      autoRoundOff === true ? totalSectionData.autoRoundOffValue : 0,
    totalAmount: netAmount,
    authorizedsignatur: fileList && fileList.length > 0 ? fileList[0] : "",
    notes: notes,
    termsandconditions: termsConditions,
    createdBy: userId,
  };

  console.log(purchaseInvoiceListData, "purchaseInvoiceListData");
  console.log(autoRoundOff, "autoRoundOff");

  //update objects
  const purchaseUpdateOrdersListData = {
    piId: piId,
    vendorId: partyModalData.vendorId,
    vendorName: vendorName,
    organizationId: organizationId,
    purchaseinvoiceNo: poNo,
    purchaseinvoiceDate: poDate,
    dueDate: validDate,
    paymentTerms: paymentTerms,
    financialyearId: financialyearId,
    vendorAddress: [
      {
        address1: partyModalData.billingAddress,
        country: "India",
        state: !isEmpty(updatedData) ? partyModalData.state : stateData,
        pincode: pincode,
        city: partyModalData.cityName,
      },
    ],
    vendorPhone: partyModalData.mobile,
    items:
      itemSelectedRows.length > 0
        ? itemSelectedRows.map((data) => {
            const purchaseItemPrice = parseFloat(data.purchasePrice);
            const salesPriceItemPrice = parseFloat(data.salesPrice);
            return {
              itemId: data._id,
              gradeId: !isEmpty(gradeListValue) ? gradeListValue : gradeList,
              qty: data.quantityCount,
              ramId: data.ramId,
              sellingprice: data.salesPrice && Math.round(salesPriceItemPrice),
              purchaseprice:
                data.purchasePrice && Math.round(purchaseItemPrice),
              discount: data.discountPrice,
              discountPercentage:
                data.discountPercentage && parseFloat(data.discountPercentage),
              taxId: data.taxPercentageId,
              tax:
                data.taxValue !== null || !isEmpty(data.taxValue)
                  ? data.taxValue
                  : 0,
              totalAmount: parseFloat(data.totalAmount),
              itemupdateId: data.itemUpdateId,
            };
          })
        : [],
    subtotalamount:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.totalAmount : 0,
    subtotaldiscount:
      itemSelectedRows && itemSelectedRows.length > 0
        ? totals.discountPrice
        : 0,
    subtotaltax:
      itemSelectedRows && itemSelectedRows.length > 0 ? totals.taxValue : 0,
    charges:
      !isEmpty(totalSectionData.additionalCharges) &&
      totalSectionData.chargeId == ""
        ? [
            {
              chargeAmount: totalSectionData.additionalCharges,
              chargeName: totalSectionData.chargesData,
            },
          ]
        : !isEmpty(totalSectionData.additionalCharges) &&
          totalSectionData.chargeId !== ""
        ? [
            {
              chargeAmount: totalSectionData.additionalCharges,
              chargeName: totalSectionData.chargesData,
              _id: totalSectionData.chargeId,
            },
          ]
        : "",
    discountPercentage: totalSectionData.discountPercent
      ? totalSectionData.discountPercent
      : 0,
    discountAmount: totalSectionData.discountAmount
      ? totalSectionData.discountAmount
      : 0,
    totalAmount: netAmount,
    autoroundoff: autoRoundOff === true ? true : false,
    isautoroundoffadd:
      autoRoundOff === true && autoRoundOffMethod.value == "add" ? true : false,
    isautoroundoffreduce:
      autoRoundOff === true && autoRoundOffMethod.value == "reduce"
        ? true
        : false,
    autoroundoffamount:
      autoRoundOff === true ? totalSectionData.autoRoundOffValue : 0,
    isType: !isEmpty(prefixValue) ? "isPurchase" : "",
    authorizedsignatur: fileList && fileList.length > 0 ? fileList[0] : "",
    notes: notes,
    termsandconditions: termsConditions,
    updatedBy: userId,
  };

  console.log(autoRoundOffMethod, "autoRoundOffMethod");

  const purchaseOrdersList = Object.keys(purchaseInvoiceListData).forEach(
    (k) =>
      (purchaseInvoiceListData[k] == "" ||
        purchaseInvoiceListData[k] == undefined) &&
      delete purchaseInvoiceListData[k]
  );
  const purchaseUpdateOrdersList = Object.keys(
    purchaseUpdateOrdersListData
  ).forEach(
    (k) =>
      (purchaseUpdateOrdersListData[k] == "" ||
        purchaseUpdateOrdersListData[k] == undefined) &&
      delete purchaseUpdateOrdersListData[k]
  );

  console.log(
    purchaseUpdateOrdersList,
    purchaseOrdersList,
    "purchaseUpdateOrdersList"
  );
  console.log(purchaseUpdateOrdersListData, "purchaseUpdateOrdersListData");

  const purchaseMandatory =
    itemSelectedRows && itemSelectedRows.length > 0
      ? itemSelectedRows.filter(
          (data) =>
            data.purchasePrice == null ||
            data.purchasePrice == "" ||
            data.purchasePrice == undefined
        )
      : [];

  //Create Purchase Invoice
  const createPurchaseInvoiceApi = () => {
    if (
      simpleValidator.current.allValid() &&
      partyModalData.billingAddress &&
      purchaseMandatory.length == 0
      // poNo !== "" &&
      // !isEmpty(poDate) &&
      // !isEmpty(validDate) &&
      // !isEmpty(gradeList) &&
      // partyModalData.billingAddress &&
      // purchaseMandatory.length == 0
    ) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 7000);

      purchaseInvoiceListData.isautoroundoffadd =
        autoRoundOff === true && autoRoundOffMethod.value == "add"
          ? true
          : false;
      purchaseInvoiceListData.isautoroundoffreduce =
        autoRoundOff === true && autoRoundOffMethod.value == "reduce"
          ? true
          : false;
      api
        .post("/org/createpurchaseinvoice", purchaseInvoiceListData)
        .then((res) => {
          toast.success("Purchase Invoice created successfully ");
          dispatch(loadPurchaseInvoice(purchaseList));
          setTimeout(() => {
            history.push("/purchase-invoice");
          }, 2500);

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while adding the purchase"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (
        !isEmpty(partyModalData.billingAddress) &&
        purchaseMandatory.length == 0
      ) {
        console.log("no error");
      } else {
        toast.error(
          `${
            isEmpty(partyModalData.billingAddress) &&
            purchaseMandatory.length > 0
              ? "Billing from, purchase price field is required"
              : !isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length > 0
              ? "Purchase price field is required"
              : isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length == 0
              ? "Billing from field is required"
              : ""
          }`
        );
      }
    }
  };
  console.log(gradeList, purchaseMandatory);
  const clearFields = () => {
    setPartyModalData({
      ...partyModalData,
      _id: "",
      vendorName: "",
      totalAddress: "",
      billingAddress: "",
      cityName: "",
      state: "",
      vendorId: "",
    });
    setPiId("");
    setVendorName("");
    setPincode("");
    setStateData([]);

    setFileList([]);
    setUpdatePreviewImage("");
    setPaymentTerms(paymentTermsOnly + 1);
    setPoDate(poDateValue);
    setGradeList([]);
    setGradeListValue("");
    setValidDate(validDateValue);
    dispatch(loadPurchaseRecordsMetaData());
    setItemSelectedRows([]);
    setNotesOpen(false);
    setNotes("");
    setTermsOpen(false);

    setAdditionalChargesOpen(false);

    setTermsConditions("");

    //total section data
    setTotalSectionData({
      ...totalSectionData,
      totalAmount: "",
      autoRoundOffValue: "",
      chargesData: "",
      // netAmount: updatedData.NetAmount,
      additionalCharges: "",
      chargeId: "",
    });
    setAutoRoundOffMethod([]);
    // setAdditionalOptions("");
  };

  const [isNewButtonDisabled, setIsNewButtonDisabled] = useState(false);
  //Create Purchase Invoice
  const createPurchaseNewInvoiceApi = () => {
    if (
      simpleValidator.current.allValid() &&
      partyModalData.billingAddress &&
      purchaseMandatory.length == 0
      // poNo !== "" &&
      // !isEmpty(poDate) &&
      // !isEmpty(validDate) &&
      // !isEmpty(gradeList) &&
      // partyModalData.billingAddress &&
      // purchaseMandatory.length == 0
    ) {
      purchaseInvoiceListData.isautoroundoffadd =
        autoRoundOff === true && autoRoundOffMethod.value == "add"
          ? true
          : false;
      purchaseInvoiceListData.isautoroundoffreduce =
        autoRoundOff === true && autoRoundOffMethod.value == "reduce"
          ? true
          : false;
      setIsNewButtonDisabled(true);
      setTimeout(() => {
        setIsNewButtonDisabled(false);
      }, 7000);
      api
        .post("/org/createpurchaseinvoice", purchaseInvoiceListData)
        .then((res) => {
          toast.success("Purchase Invoice created successfully ");
          dispatch(loadPurchaseInvoice(purchaseList));
          dispatch(loadPrefixSettingsList(purchasePrefixList));
          setTimeout(() => {
            clearFields();
          }, 1000);

          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while adding the purchase"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (
        !isEmpty(partyModalData.billingAddress) &&
        purchaseMandatory.length == 0
      ) {
        console.log("no error");
      } else {
        toast.error(
          `${
            isEmpty(partyModalData.billingAddress) &&
            purchaseMandatory.length > 0
              ? "Billing from, purchase price field is required"
              : !isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length > 0
              ? "Purchase price field is required"
              : isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length == 0
              ? "Billing from field is required"
              : ""
          }`
        );
      }
    }
  };

  //update Purchase Invoice
  const updatePurchaseInvoiceApi = () => {
    if (
      simpleValidator.current.allValid() &&
      partyModalData.billingAddress &&
      purchaseMandatory.length == 0
      // poNo !== "" &&
      // !isEmpty(poDate) &&
      // !isEmpty(validDate) &&
      // !isEmpty(gradeList) &&
      // partyModalData.billingAddress &&
      // purchaseMandatory.length == 0
    ) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 7000);
      purchaseUpdateOrdersListData.isautoroundoffadd =
        autoRoundOff == true && autoRoundOffMethod.value == "add"
          ? true
          : false;
      purchaseUpdateOrdersListData.isautoroundoffreduce =
        autoRoundOff == true && autoRoundOffMethod.value == "reduce"
          ? true
          : false;
      api
        .put("/org/updatepurchaseinvoice", purchaseUpdateOrdersListData)
        .then((res) => {
          toast.success("Purchase Invoice updated successfully");
          dispatch(loadPurchaseInvoice(purchaseList));
          setTimeout(() => {
            history.push("/purchase-invoice");
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(
            errorMsg || "There is a an issue while adding the purchase"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (
        !isEmpty(partyModalData.billingAddress) &&
        purchaseMandatory.length == 0
      ) {
        console.log("no error");
      } else {
        toast.error(
          `${
            isEmpty(partyModalData.billingAddress) &&
            purchaseMandatory.length > 0
              ? "Billing from, purchase price field is required"
              : !isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length > 0
              ? "Purchase price field is required"
              : isEmpty(partyModalData.billingAddress) &&
                purchaseMandatory.length == 0
              ? "Billing from field is required"
              : ""
          }`
        );
      }
    }
  };

  useBeforeUnload({
    when: !isEmpty(totalSectionData),
    message: "Are you sure you want to leave?",
  });
  console.log(itemSelectedRows, "itemSelectedRows");
  console.log(updatedData, "updatedData");
  //updated data
  useEffect(() => {
    if (updatedData) {
      const vendorAddressData =
        updatedData.vendorAddress &&
        updatedData.vendorAddress.length > 0 &&
        updatedData.vendorAddress[0];
      const totalAddress =
        vendorAddressData.city &&
        vendorAddressData.stateName &&
        vendorAddressData.pincode
          ? vendorAddressData.address1 +
            ", " +
            vendorAddressData.city +
            ", " +
            vendorAddressData.stateName +
            ", " +
            vendorAddressData.pincode
          : vendorAddressData.address1 + ", " + vendorAddressData.city;
      setPartyModalData({
        ...partyModalData,
        _id: updatedData ? updatedData._id : "",
        vendorName: updatedData.vendorName,
        totalAddress: totalAddress,
        billingAddress: vendorAddressData ? vendorAddressData.address1 : "",
        cityName: vendorAddressData ? vendorAddressData.city : "",
        state: vendorAddressData ? vendorAddressData.state : "",
        vendorId: updatedData ? updatedData.vendorId : "",
      });
      setPiId(updatedData._id);
      setVendorName(updatedData.vendorName);
      setPincode(vendorAddressData.pincode);
      setStateData(vendorAddressData.stateName);
      const updatedPoNo = updatedData ? updatedData.purchaseinvoiceNo : "";
      const updatedPaymentTerms =
        updatedData && updatedData.paymentTerms !== undefined
          ? parseInt(updatedData.paymentTerms)
          : 0;
      const updatedPoDate = updatedData
        ? moment(updatedData.purchaseinvoiceDate).format("YYYY-MM-DD")
        : "";
      const updatedValidDate =
        updatedData && updatedData.dueDate
          ? moment(updatedData.dueDate).format("YYYY-MM-DD")
          : "";
      setPoNo(updatedPoNo);
      setFileList(
        updatedData.authorizedsignatur ? [updatedData.authorizedsignatur] : []
      );
      setUpdatePreviewImage(
        updatedData.authorizedsignatur ? updatedData.authorizedsignatur : ""
      );
      // setOrgInvoiceNo(orginvoiceNo)
      setPaymentTerms(updatedPaymentTerms);
      // if (updatedPaymentTerms === 0) {
      //   const date = moment().format("YYYY-MM-DD");
      //   setValidDate(date);
      // } else
      if (updatedPaymentTerms >= 0) {
        const date = moment()
          .add(updatedPaymentTerms, "days")
          .format("YYYY-MM-DD");
        setValidDate(date);
      } else {
        setValidDate(validDateValue);
      }
      setPoDate(updatedPoDate);
      const gradeList =
        updatedData && updatedData.items.length > 0 && updatedData.items[0];
      setGradeList(gradeList.gradeName);
      setGradeListValue(gradeList.gradeId);
      setValidDate(updatedValidDate);

      dispatch(loadPurchaseRecordsMetaData());
      const updatedItemValues =
        updatedData && updatedData.items.length > 0
          ? updatedData.items.map((data) => {
              const quantityCount = data.qty
                ? parseInt(data.qty * data.purchasePrice)
                : data.purchaseprice;
              const ramDetails =
                data.serialDetails && data.serialDetails.length > 0
                  ? data.serialDetails[0]
                  : "";

              // const discountPercentageValue =
              //   data.discount !== "" &&
              //   parseFloat((data.discount * 100) / data.purchasePrice);
              // console.log(discountPercentageValue, "discountPercentageValue");
              // const roundValues =
              //   discountPercentageValue && Math.round(discountPercentageValue);
              return {
                discountPrice: data.discount ? data.discount : 0,
                discountPercentage: data.discountPercentage
                  ? data.discountPercentage
                  : 0,
                // discountPercentage: discountPercentageValue ? roundValues : 0,
                _id: data.itemId,
                hsnCode: data.hsnCode ? data.hsnCode : "",
                quantityCount: data.qty,
                noofStock: data.qty ? data.qty : quantityCount <= 18 ? 1 : 0,
                itemName: data.modelName,
                purchasePrice:
                  data.purchasePrice &&
                  parseFloat(data.purchasePrice).toFixed(2),
                salesPrice: data.sellingPrice,
                taxValue: data.tax,
                taxPercentageId: data.taxId,
                taxPercentageName: data.taxName,
                ramId: ramDetails ? ramDetails.RAM : "",
                ramName: ramDetails ? ramDetails.ramName : "",
                totalAmount:
                  data.totalAmount && parseFloat(data.totalAmount).toFixed(2),
                itemUpdateId: data._id,
              };
            })
          : [];
      setItemSelectedRows(updatedItemValues);
      if (updatedData.notes) {
        setNotesOpen(true);
      }
      setNotes(updatedData.notes);
      if (updatedData.termsandconditions) {
        setTermsOpen(true);
      }
      if (updatedData.autoamountroundoff) {
        setAdditionalChargesOpen(true);
      }

      setTermsConditions(updatedData.termsandconditions);
      const chargesValue =
        updatedData && updatedData.charges.length > 0
          ? updatedData.charges[0]
          : "";
      // const chargeNameValue =
      //   updatedData && chargesValue ? chargesValue.chargeName : "";
      // const chargeName =
      //   chargeNameValue && !isEmpty(chargeNameValue)
      //     ? chargeNameValue
      //     : "No Tax Applicable";

      const discountPercentageValue = updatedData.discountAmount
        ? parseFloat(
            (100 * updatedData.discountAmount) / updatedData.subtotalamount
          ).toFixed(2)
        : 0;
      //total section data
      setTotalSectionData({
        ...totalSectionData,
        totalAmount: updatedData.totalAmount,
        autoRoundOffValue: updatedData.autoroundoffamount,
        chargesData: updatedData.chargeName,
        discountAmount: updatedData.discountAmount
          ? updatedData.discountAmount
          : 0,
        // discountPercent: data.discountPercentage,
        discountPercent: discountPercentageValue,
        // netAmount: updatedData.NetAmount,
        additionalCharges:
          chargesValue && !isUndefined(chargesValue.chargeAmount)
            ? chargesValue.chargeAmount
            : 0,
        chargeId:
          chargesValue && !isUndefined(chargesValue._id)
            ? chargesValue._id
            : "",
      });
      if (updatedData.discountAmount) {
        setDiscountOpen(true);
      }
      if (chargesValue.chargeAmount !== undefined) {
        setAdditionalChargesOpen(true);
      }
      // if(auto)
      setAutoRoundOffMethod(
        updatedData.isautoroundoffadd == true
          ? { label: "+ Add", value: "add" }
          : updatedData.isautoroundoffreduce &&
            updatedData.isautoroundoffreduce == true
          ? { label: "+ Reduce", value: "reduce" }
          : []
      );
      setAutoRoundOff(updatedData.autoroundoff);
      // setAdditionalOptions(chargeName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);
  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);

  //Prefix settings list
  const createPrefixSettings = () => {
    if (purchaseSettings.prefix && purchaseSettings.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 6000);
      const prefixList = {
        organizationId: organizationId,
        prefix: purchaseSettings.prefix,
        sequenceNo: purchaseSettings.seqNo,
        isType: "isPurchase",
        isEnable: invoiceShow === true ? true : false,
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(purchasePrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed
  console.log(poNo, "poNo");
  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable === true) {
      setPurchaseSettings({
        ...purchaseSettings,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      // const prefixInvoiceNo =
      //   prefix_settings_list.lastprefixName +
      //   "" +
      //   prefix_settings_list.lastsequenceNo;
      setPoNo(
        (!isEmpty(updatedData) || updatedData !== undefined) &&
          updatedData.purchaseinvoiceNo
          ? updatedData.purchaseinvoiceNo
          : prefix_settings_list.lastsequenceNo
      );
      setPrefixValue(prefix_settings_list.lastprefixName);
      setInvoiceShow(true);
    } else {
      setPurchaseSettings({
        ...purchaseSettings,
        prefix: "",
        seqNo: "",
      });
      // const prefixInvoiceNo =
      //   prefix_settings_list.lastprefixName +
      //   "" +
      //   prefix_settings_list.lastsequenceNo;
      setPoNo(
        updatedData !== undefined && updatedData.purchaseinvoiceNo
          ? updatedData.purchaseinvoiceNo
          : ""
      );
      setPrefixValue("");
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  const piResponsive =
    prefix_settings_list && prefix_settings_list.isEnable === true ? 12 : 12;
  const piDateResponsive =
    prefix_settings_list && prefix_settings_list.isEnable === true ? 12 : 10;
  const paymentTermsResponsive =
    prefix_settings_list && prefix_settings_list.isEnable === true
      ? 12
      : prefix_settings_list && prefix_settings_list.isEnable === false
      ? 13
      : 12;

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>
            {" "}
            {!isEmpty(updatedData) ? "Update Purchase" : "Add Purchase"} | Mbook
          </title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
          {initialLoading == true ? <Spinners type="Transactions" /> : ""}
        </Col> */}
        <Col span={24}>
          <div
            className={
              media == "sm" || media == "xs"
                ? "border border-b-1 border-x-0 border-t-0 font-poppins flex flex-col pl-[20px] pr-[20px] mt-4"
                : "border border-b-1 border-x-0 border-t-0 font-poppins flex justify-between pl-[20px] pr-[20px] mt-3 pb-2"
            }
          >
            <div className={"flex"}>
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className={
                  media == "sm" || media == "xs"
                    ? "text-[16px] ml-2 mb-3 mt-1 font-semibold"
                    : "text-[18px] ml-2 mt-1 font-semibold"
                }
              >
                {!isEmpty(updatedData)
                  ? "Update Purchase Invoice"
                  : "Create Purchase Invoice"}
              </h1>
            </div>
            <div
              className={
                media == "sm" || media == "xs" ? "flex flex-col" : "flex"
              }
            >
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className={
                    media == "sm" || media == "xs"
                      ? "flex justify-center border rounded-md ml-3 pt-1.5 pb-1.5 mb-2 cursor-pointer"
                      : "border rounded-md mr-3 pt-1.5 pb-1.5 pr-6 pl-6 cursor-pointer"
                  }
                  style={{
                    fontFamily: "Poppins",
                  }}
                >
                  Settings <SettingOutlined />
                </div>
              </Tooltip>
              {updatedData && updatedData._id ? (
                ""
              ) : (
                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "flex justify-center border rounded-md hover:bg-[#efefef] ml-3 p-1 mb-2 cursor-pointer"
                      : "border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer"
                  }
                  style={{
                    fontFamily: "Poppins",
                    pointerEvents: isNewButtonDisabled ? "none" : "auto",
                    opacity: isNewButtonDisabled ? 2 : "",
                  }}
                  onClick={() => createPurchaseNewInvoiceApi()}
                >
                  Save & New
                </div>
              )}

              <div
                style={{
                  fontFamily: "Poppins",
                  pointerEvents: isButtonDisabled ? "none" : "auto",
                  opacity: isButtonDisabled ? 2 : "",
                }}
                onClick={() => {
                  if (!isEmpty(updatedData)) {
                    updatePurchaseInvoiceApi();
                  } else {
                    createPurchaseInvoiceApi();
                  }
                }}
                className={
                  media == "sm" || media == "xs"
                    ? "flex justify-center border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 p-1.5 cursor-pointer"
                    : "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                }
              >
                {!isEmpty(updatedData) ? "Update" : "Save"}
              </div>
            </div>
          </div>
        </Col>
        <div
          className={
            windowDimensions.height >= 500 && windowDimensions.height <= 600
              ? "add-purchase-invoices-tab-device-main pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 600 && windowDimensions.height <= 650
              ? "add-purchase-invoices-large-tab-device-main pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 700 && windowDimensions.height <= 800
              ? "add-purchase-invoices-main-large-device pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 800 && windowDimensions.height <= 900
              ? "add-purchase-invoices-main-extra-large-device pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 900 && windowDimensions.height <= 960
              ? "add-purchase-invoices-main-extra-extra-large-device pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 960 &&
                windowDimensions.height <= 1000
              ? "add-purchase-invoices-main-extra-extra-large-based-device pr-4 pl-5 pt-3 mt-1"
              : windowDimensions.height >= 1000
              ? "add-purchase-invoices-main-infinite-extra-large-device pr-4 pl-5 pt-3 mt-1"
              : "add-purchase-invoices-main pr-4 pl-5 pt-3 mt-1"
          }
        >
          <Col span={24} className="add-purchase-card">
            {/* File form section */}
            <Row className="border border-t-0 border-r-0 border-b-1">
              <Col
                md={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 13
                    : 15
                }
                lg={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 13
                    : 15
                }
                xl={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 13
                    : 15
                }
                xxl={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 13
                    : 15
                }
                sm={24}
                xs={24}
                className={
                  media == "sm" || media == "xs"
                    ? "flex border border-b-1 border-t-0 border-x-0"
                    : "flex border border-r-1 border-l-0 border-b-0 border-t-0"
                }
              >
                <Row className="w-[100%]">
                  <Col
                    span={
                      !isEmpty(partyModalData._id) &&
                      !isEmpty(partyModalData.vendorName)
                        ? 12
                        : 24
                    }
                  >
                    <div className="w-[100%] flex justify-between border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                      <h1 className="ml-3 purchase-label flex text-[14px] font-medium">
                        Bill From <p className="text-[red] ml-1">*</p>
                      </h1>
                      {!isEmpty(partyModalData._id) &&
                      !isEmpty(partyModalData.vendorName) ? (
                        <div className="">
                          <div
                            onClick={() => {
                              setPartyModal(true);
                              setPartyMode("Add");
                              dispatch(loadVendor(purchaseList));
                            }}
                            className="text-center text-[11px] cursor-pointer border border-1 rounded-md border-gray-400 pl-2 pr-2"
                          >
                            Change Vendor
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <Row className="p-6">
                      {partyModal === true ? (
                        <Col
                          span={
                            !isEmpty(partyModalData._id) &&
                            !isEmpty(partyModalData.vendorName)
                              ? 20
                              : 16
                          }
                          className="purchase-party-card"
                        >
                          <Row className="flex flex-col mb-1">
                            <Col
                              span={24}
                              className="flex justify-end pt-2 pr-2"
                            >
                              <CloseCircleOutlined
                                onClick={() => setPartyModal(false)}
                              />
                            </Col>
                            <Col span={24} className="pr-3 pl-3 pt-2 pb-2">
                              <AutoComplete className="mt-2 border border-none rounded-sm mb-2 w-[100%] mr-2">
                                <Input.Search
                                  size="large"
                                  placeholder="Search party by name or phone number"
                                  value={search}
                                  onChange={(e) => handleSearch(e)}
                                  // enterButton
                                />
                              </AutoComplete>
                            </Col>
                            <Col span={24} className="">
                              <div>
                                <div className="purchase-label flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 text-[14px]">
                                    Party Name
                                  </h1>
                                  <p className="mr-2 text-[14px]">Balance</p>
                                </div>
                                <div className="purchase-label bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                  <h1 className="ml-2 font-semibold text-[14px]">
                                    Cash Sale
                                  </h1>
                                  <p className="mr-2 font-semibold text-[14px]">
                                    0.0
                                  </p>
                                </div>
                                <div
                                  className={
                                    vendorRows.length > 3
                                      ? "purchase-party-scroll"
                                      : ""
                                  }
                                >
                                  {vendorRows &&
                                  vendorRows.length > 0 &&
                                  vendorRows[0].vendorName
                                    ? vendorRows.map((data, index) => {
                                        const billingAddressData =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].address1
                                            : "";
                                        const billingAddressState =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].state
                                            : "";
                                        const billingAddressStateName =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].stateName
                                            : "";
                                        const billingAddressPincode =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].pincode
                                            : "";
                                        const billingAddressCity =
                                          data &&
                                          data.billingAddress &&
                                          data.billingAddress.length > 0
                                            ? data.billingAddress[0].city
                                            : "";

                                        const totalBillingAddress =
                                          !isEmpty(billingAddressData) &&
                                          billingAddressCity !== undefined &&
                                          billingAddressStateName !==
                                            undefined &&
                                          billingAddressPincode
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              ", " +
                                              billingAddressStateName +
                                              ", " +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              billingAddressCity &&
                                              billingAddressStateName ===
                                                undefined &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressCity +
                                              " ," +
                                              billingAddressPincode
                                            : !isEmpty(billingAddressData) &&
                                              !isEmpty(billingAddressPincode)
                                            ? billingAddressData +
                                              ", " +
                                              billingAddressPincode
                                            : "";

                                        //shipping address
                                        const shippingAddressData =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].address1
                                            : "";
                                        const shippingAddressState =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].state
                                            : "";
                                        const shippingAddressStateName =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].stateName
                                            : "";
                                        // const shippingAddressCityName =
                                        //   data &&
                                        //   data.shippingAddress &&
                                        //   data.shippingAddress.length > 0
                                        //     ? data.shippingAddress[0].city
                                        //     : "";
                                        const shippingAddressPincode =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].pincode
                                            : "";
                                        const shippingAddressCity =
                                          data &&
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? data.shippingAddress[0].city
                                            : "";
                                        const totalAddress =
                                          data.shippingAddress &&
                                          data.shippingAddress.length > 0
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressCity +
                                              ", " +
                                              shippingAddressStateName +
                                              ", " +
                                              shippingAddressPincode
                                            : !isEmpty(shippingAddressData) &&
                                              shippingAddressCity &&
                                              !isEmpty(shippingAddressPincode)
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressCity +
                                              " ," +
                                              shippingAddressPincode
                                            : !isEmpty(shippingAddressData) &&
                                              !isEmpty(shippingAddressPincode)
                                            ? shippingAddressData +
                                              ", " +
                                              shippingAddressPincode
                                            : "";
                                        return (
                                          <div
                                            key={index}
                                            className="cursor-pointer"
                                            onClick={() => {
                                              // setCreatePartyModal(false);
                                              setPartyModal(false);
                                              setPartyModalData({
                                                vendorName: data.vendorName
                                                  ? data.vendorName
                                                  : "",
                                                mobile: data.mobileNo
                                                  ? data.mobileNo
                                                  : "",
                                                billingAddress:
                                                  shippingAddressData,
                                                cityName: shippingAddressCity
                                                  ? shippingAddressCity
                                                  : "",
                                                gstIn: data.gstIn
                                                  ? data.gstIn
                                                  : "",
                                                totalAddress: totalAddress,
                                                state: shippingAddressState,
                                                _id: data._id,
                                                billingCityName:
                                                  billingAddressCity,
                                                billingAddressValue:
                                                  billingAddressData,
                                                totalBillingAddress:
                                                  totalBillingAddress,
                                                billingState:
                                                  billingAddressState,
                                              });
                                              setPincode(
                                                shippingAddressPincode
                                              );
                                              setStateData(
                                                shippingAddressStateName
                                              );
                                              setBillingPincode(
                                                billingAddressPincode
                                              );
                                              setBillingStateData(
                                                billingAddressStateName
                                              );
                                              // setPartyMode("Update");
                                            }}
                                          >
                                            {tableLoading ? (
                                              <Skeleton.Input
                                                style={{
                                                  margin: "6px 3px",
                                                  minWidth: "120%",
                                                  height: "60px",
                                                }}
                                                className="border border-b-1.5 border-x-0 border-t-0"
                                                // className="tabs-skeleton"
                                                active={true}
                                                size={"large"}
                                              ></Skeleton.Input>
                                            ) : (
                                              <div className="purchase-label hover:bg-[#e9ecf1] flex border p-2 border-b-1.5 border-x-0 border-t-0 justify-between">
                                                <h1 className="ml-2 text-[14px]">
                                                  {data.vendorName}
                                                </h1>
                                                <p className="mr-2 flex text-[14px]">
                                                  <p className="mr-2">
                                                    {data.openingbalanceType ===
                                                    "To Collect" ? (
                                                      <ArrowDownOutlined className="text-[green]" />
                                                    ) : (
                                                      ""
                                                    )}
                                                  </p>{" "}
                                                  {data.currentBalance &&
                                                    parseFloat(
                                                      data.currentBalance
                                                    ).toFixed(2)}
                                                </p>
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    : ""}
                                </div>
                              </div>
                            </Col>
                            <Col span={24} className="p-3">
                              <div
                                onClick={() => {
                                  setCreatePartyModal(true);
                                  dispatch(loadPurchaseRecordsMetaData());
                                  setPartyModalData({
                                    ...partyModalData,
                                    vendorId: "",
                                    vendorName: "",
                                    mobile: "",
                                    billingAddress: "",
                                    cityName: "",
                                    billingCityName: "",
                                  });
                                  setPincode("");
                                  setStateData([]);
                                  setBillingPincode("");
                                  setBillingStateData([]);
                                }}
                                className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-2 pb-2 pl-10 pr-10"
                              >
                                <PlusOutlined /> Create Vendor
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      ) : !isEmpty(partyModalData._id) &&
                        !isEmpty(partyModalData.vendorName) ? (
                        <Row className="ml-[-6px] w-[100%] mb-6">
                          <Col span={24}>
                            <div>
                              <h1 className="purchase-label text-[14px] font-semibold">
                                {!isEmpty(partyModalData.vendorName) &&
                                  partyModalData.vendorName}
                              </h1>
                              {/* <div className="flex">
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Address:
                                </p>
                                <p>
                                  {partyModalData &&
                                  partyModalData.totalBillingAddress &&
                                  !isEmpty(partyModalData.totalBillingAddress)
                                    ? partyModalData.totalBillingAddress
                                    : ""}
                                </p>
                              </div> */}
                            </div>
                          </Col>
                        </Row>
                      ) : (
                        <div className="w-[50%]">
                          <div
                            onClick={() => {
                              setPartyModal(true);
                              setPartyMode("Add");
                              dispatch(loadVendor(purchaseList));
                            }}
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="text-center text-[#488dff] cursor-pointer border border-dashed border-2 border-blue-400 p-5"
                          >
                            <PlusOutlined /> Add Vendor
                          </div>
                          {/* {simpleValidator.current.message(
                            "billingAddress",
                            partyModalData.billingAddress,
                            "required"
                          )} */}
                        </div>
                      )}
                    </Row>
                  </Col>
                  <Col
                    span={12}
                    className="border border-l-1 border-t-0 border-r-0 border-b-0"
                  >
                    {!isEmpty(partyModalData._id) &&
                    !isEmpty(partyModalData.vendorName) ? (
                      <>
                        <div className="flex justify-between border p-1.5 border-l-0 border-t-0 border-r-0 border-b-1">
                          <h1 className="ml-3 purchase-label text-[14px] font-medium">
                            Ship From
                          </h1>

                          <div className="">
                            <div
                              onClick={() => {
                                setCreateShippingModal(true);
                                // dispatch(loadVendor(purchaseList));
                                dispatch(
                                  loadPartyVendorAddress({
                                    partyorvendorId: partyModalData._id,
                                    organizationId: organizationId,
                                  })
                                );
                                dispatch(loadPurchaseRecordsMetaData());
                              }}
                              className="text-center text-[11px] cursor-pointer border border-1 rounded-md border-gray-400 pl-2 pr-2"
                            >
                              Change Shipping Address
                            </div>
                          </div>
                        </div>
                        <Row className="p-5 w-[100%] mb-6">
                          <Col span={24}>
                            <div>
                              <h1 className="purchase-label text-[14px] font-semibold">
                                {!isEmpty(partyModalData.vendorName) &&
                                  partyModalData.vendorName}
                              </h1>
                              <div className="flex">
                                <p className="text-[12px] text-[gray] mr-1 font-medium">
                                  Address:
                                </p>
                                <p>
                                  {partyModalData &&
                                  !isEmpty(partyModalData.totalAddress)
                                    ? partyModalData.totalAddress
                                    : ""}
                                </p>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Col>
              <Col
                md={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 11
                    : 9
                }
                lg={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 11
                    : 9
                }
                xl={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 11
                    : 9
                }
                xxl={
                  !isEmpty(partyModalData._id) &&
                  !isEmpty(partyModalData.vendorName)
                    ? 11
                    : 9
                }
                sm={24}
                xs={24}
              >
                <Row
                  className={
                    media == "sm" || media == "xs"
                      ? "pb-3 pl-3 pt-3"
                      : "pl-3 pt-3"
                  }
                >
                  {prefix_settings_list &&
                  prefix_settings_list.isEnable === true ? (
                    <Col
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      xs={15}
                      sm={15}
                      className="pr-3 mb-1"
                    >
                      <Typography className="input-label mb-2 text-[10px]">
                        Prefix
                      </Typography>
                      <Input
                        name="prefixValue"
                        value={prefixValue}
                        className={
                          prefix_settings_list &&
                          prefix_settings_list.isEnable === true
                            ? "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                            : "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                        }
                        onChange={(e) => setPrefixValue(e.target.value)}
                        placeholder="Enter PI No"
                      />
                    </Col>
                  ) : (
                    ""
                  )}

                  <Col
                    md={piResponsive}
                    lg={piResponsive}
                    xl={piResponsive}
                    xxl={piResponsive}
                    xs={15}
                    sm={15}
                    className={
                      prefix_settings_list &&
                      prefix_settings_list.isEnable === true
                        ? "pr-3 mb-1"
                        : "pr-3"
                    }
                  >
                    <Typography className="input-label mb-1 text-[10px]">
                      PI No: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <Input
                      name="poNo"
                      value={poNo}
                      className={
                        prefix_settings_list &&
                        prefix_settings_list.isEnable === true
                          ? "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] mt-[-4px] h-[30px] bg-[#e9ecf1]"
                          : "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      }
                      onChange={(e) => setPoNo(e.target.value)}
                      placeholder="Enter PI No"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "poNo",
                        poNo,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col
                    md={piDateResponsive}
                    lg={piDateResponsive}
                    xl={piDateResponsive}
                    xxl={piDateResponsive}
                    xs={24}
                    sm={24}
                    className="pr-3"
                  >
                    <Typography className="input-label mb-1 mt-1 text-[10px]">
                      PI Date: <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <DatePicker
                      selected={poDate}
                      toggleCalendarOnIconClick={true}
                      onChange={handlePoDateChange}
                      className={
                        windowDimensions.width > 1600 &&
                        windowDimensions.width < 1800
                          ? "rounded-md border border-1 h-[30px] w-[130%] mt-[-10px] pl-2"
                          : windowDimensions.width >= 1800
                          ? "rounded-md border border-1 h-[30px] w-[145%] mt-[-10px] pl-2"
                          : media == "sm"
                          ? "rounded-md border border-1 h-[30px] w-[180%] mt-1 mb-2 pl-2"
                          : media == "xs"
                          ? "rounded-md border border-1 h-[30px] w-[125%] mt-1 mb-2 pl-2"
                          : prefix_settings_list &&
                            prefix_settings_list.isEnable === true &&
                            (media == "md" ||
                              media == "lg" ||
                              media == "xxl" ||
                              media == "xl")
                          ? "rounded-md border border-1 h-[30px] w-[100%] pl-2"
                          : prefix_settings_list &&
                            isEmpty(prefix_settings_list._id) &&
                            (media == "md" ||
                              media == "lg" ||
                              media == "xxl" ||
                              media == "xl")
                          ? "rounded-md border border-1 h-[30px] w-[125%] pl-2"
                          : "rounded-md border border-1 h-[30px] pl-2"
                      }
                      icon={
                        <BiCalendar
                          //   size={30}
                          className={
                            windowDimensions.width > 1600 &&
                            windowDimensions.width < 1800
                              ? "top-[-6px] text-[16px] right-[-60px] text-[#9e9e9e]"
                              : windowDimensions.width >= 1800
                              ? "top-[-6px] text-[16px] right-[-73px] text-[#9e9e9e]"
                              : media == "sm"
                              ? "top-[5px] text-[16px] right-[-133px] text-[#9e9e9e]"
                              : media == "xs"
                              ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                              : prefix_settings_list &&
                                prefix_settings_list.isEnable === true &&
                                (media == "md" ||
                                  media == "lg" ||
                                  media == "xxl" ||
                                  media == "xl")
                              ? "top-[0px] text-[16px] right-[0px] text-[#9e9e9e]"
                              : prefix_settings_list &&
                                isEmpty(prefix_settings_list._id) &&
                                (media == "md" ||
                                  media == "lg" ||
                                  media == "xxl" ||
                                  media == "xl")
                              ? "top-[0px] text-[16px] right-[-30px] text-[#9e9e9e]"
                              : "top-[0px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          }
                        />
                      }
                      showIcon
                      placeholderText="Select Date"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "poDate",
                        poDate,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col
                    md={piDateResponsive}
                    lg={piDateResponsive}
                    xl={piDateResponsive}
                    xxl={piDateResponsive}
                    xs={24}
                    sm={24}
                    className={
                      prefix_settings_list &&
                      prefix_settings_list.isEnable === true &&
                      (media !== "sm" || media !== "xs")
                        ? "pr-3  mt-1"
                        : prefix_settings_list &&
                          prefix_settings_list.isEnable === true &&
                          (media == "sm" || media == "xs")
                        ? "pr-3 mt-4 pb-3  mt-1"
                        : "pr-3 mt-2  mt-1"
                    }
                  >
                    <Typography className="input-label mb-1 text-[10px]">
                      Valid Till <p className="text-[red] ml-1">*</p>
                    </Typography>
                    <DatePicker
                      placeholderText="Select Date"
                      selected={validDate}
                      toggleCalendarOnIconClick={true}
                      onChange={handleValidDateChange}
                      className={
                        windowDimensions.width > 1600 &&
                        windowDimensions.width < 1800
                          ? "rounded-md border border-1 h-[30px] w-[130%] mt-[-10px] pl-2"
                          : windowDimensions.width >= 1800
                          ? "rounded-md border border-1 h-[30px] mt-[-10px] w-[145%] pl-2"
                          : media == "sm"
                          ? "rounded-md border border-1 h-[30px] w-[180%] mt-1 pl-2"
                          : media == "xs"
                          ? "rounded-md border border-1 h-[30px] w-[125%] mt-1 pl-2"
                          : prefix_settings_list &&
                            prefix_settings_list.isEnable === true &&
                            (media == "md" ||
                              media == "lg" ||
                              media == "xxl" ||
                              media == "xl")
                          ? "rounded-md border border-1 h-[30px] w-[100%] pl-2"
                          : prefix_settings_list &&
                            isEmpty(prefix_settings_list._id) &&
                            (media == "md" ||
                              media == "lg" ||
                              media == "xxl" ||
                              media == "xl")
                          ? "rounded-md border border-1 h-[30px] w-[128%] pl-2"
                          : "rounded-md border border-1 h-[30px] pl-2"
                      }
                      icon={
                        <BiCalendar
                          //   size={30}
                          className={
                            windowDimensions.width > 1600 &&
                            windowDimensions.width < 1800
                              ? "top-[-6px] text-[16px] right-[-60px] text-[#9e9e9e]"
                              : windowDimensions.width >= 1800
                              ? "top-[-6px] text-[16px] right-[-73px] text-[#9e9e9e]"
                              : media == "sm"
                              ? "top-[5px] text-[16px] right-[-133px] text-[#9e9e9e]"
                              : media == "xs"
                              ? "top-[5px] text-[16px] right-[-30px] text-[#9e9e9e]"
                              : prefix_settings_list &&
                                prefix_settings_list.isEnable === true &&
                                (media == "md" ||
                                  media == "lg" ||
                                  media == "xxl" ||
                                  media == "xl")
                              ? "top-[0px] text-[16px] right-[0px] text-[#9e9e9e]"
                              : prefix_settings_list &&
                                isEmpty(prefix_settings_list._id) &&
                                (media == "md" ||
                                  media == "lg" ||
                                  media == "xxl" ||
                                  media == "xl")
                              ? "top-[0px] text-[16px] right-[-30px] text-[#9e9e9e]"
                              : "top-[0px] text-[16px] right-[-30px] text-[#9e9e9e]"
                          }
                        />
                      }
                      showIcon
                    />
                  </Col>
                  <Col
                    md={paymentTermsResponsive}
                    lg={paymentTermsResponsive}
                    xl={paymentTermsResponsive}
                    xxl={paymentTermsResponsive}
                    xs={15}
                    sm={15}
                    className={
                      prefix_settings_list &&
                      isEmpty(prefix_settings_list._id) &&
                      windowDimensions.width > 766 &&
                      windowDimensions.width < 800
                        ? "pl-11 mb-2 mt-2"
                        : prefix_settings_list &&
                          isEmpty(prefix_settings_list._id) &&
                          windowDimensions.width >= 800 &&
                          windowDimensions.width < 1000
                        ? "pl-11 mb-2 mt-2"
                        : prefix_settings_list &&
                          isEmpty(prefix_settings_list._id) &&
                          windowDimensions.width >= 1000 &&
                          windowDimensions.width < 1800
                        ? "pl-11 mb-2 mt-2"
                        : prefix_settings_list &&
                          isEmpty(prefix_settings_list._id) &&
                          windowDimensions.width >= 1800
                        ? "pl-[3rem] mb-2 mt-2"
                        : "pr-3 mb-2 mt-2"
                    }
                  >
                    <Typography className="input-label mb-2 text-[10px]">
                      Payment Terms
                    </Typography>
                    <Input
                      name="prefixValue"
                      value={paymentTerms}
                      className={
                        prefix_settings_list &&
                        prefix_settings_list.isEnable === true
                          ? "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                          : "rounded-md border-none hover:bg-[#e9ecf1] focus:bg-[#e9ecf1] h-[30px] bg-[#e9ecf1]"
                      }
                      onChange={(e) => {
                        setPaymentTerms(e.target.value);
                        // if (e.target.value === 0) {
                        //   const date = moment().format("YYYY-MM-DD");
                        //   setValidDate(date);
                        // } else
                        if (e.target.value >= 0) {
                          const date = moment()
                            .add(e.target.value, "days")
                            .format("YYYY-MM-DD");
                          setValidDate(date);
                        } else {
                          setValidDate(validDateValue);
                        }
                      }}
                      placeholder="Enter Payment terms"
                      addonAfter={"Days"}
                    />
                    {/* <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "paymentTerms",
                        paymentTerms,
                        "required"
                      )}
                    </p> */}
                  </Col>
                  <Col
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    xs={15}
                    sm={15}
                    className={
                      prefix_settings_list &&
                      prefix_settings_list.isEnable === true
                        ? "pr-3 mb-2 mt-2"
                        : "pr-3 mb-2 mt-1"
                    }
                  >
                    <Typography
                      className={
                        media == "sm" || media == "xs"
                          ? "input-label text-[10px]"
                          : "input-label mb-[-7px] text-[10px]"
                      }
                    >
                      Grade List
                      <p className="text-[red] text-[12px] ml-2">*</p>
                    </Typography>
                    <Select
                      name="paymentMode"
                      value={gradeList}
                      onChange={(e) => {
                        setGradeList(e);
                      }}
                      placeholder="Select Grade"
                      className="w-[100%] h-[30px]"
                      options={gradeListOptions}
                      suffixIcon={
                        !isEmpty(gradeList) ? (
                          <CloseCircleOutlined
                            onClick={() => setGradeList([])}
                          />
                        ) : (
                          <DownOutlined />
                        )
                      }
                      // allowClear
                      // clearIcon
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "gradeList",
                        gradeList,
                        "required"
                      )}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* Item table section */}
            <Row className="border border-x-0 border-y-0 p-5">
              <Col
                span={24}
                className="p-2 add-create-item-table  border border-x-0 border-y-0"
              >
                <table className="table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-head uppercase text-[12px] font-medium">
                        No
                      </th>
                      <th className="w-[22%] table-head uppercase text-[12px] font-medium">
                        Items/ Services
                      </th>
                      <th className="w-[12%] table-head uppercase text-[12px] font-medium">
                        RAM
                      </th>
                      {purchaseData.quantity === true ? (
                        <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                          Qty
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.price === true ? (
                        <th className="w-[11%] table-head uppercase text-[12px]">
                          <h1 className="input-purchase-label font-medium">
                            {" "}
                            Pur.Price <p className="text-[red] ml-1">*</p>
                          </h1>
                        </th>
                      ) : (
                        ""
                      )}
                      {purchaseData.sellingPrice === true ? (
                        <th className="w-[11%] table-head uppercase text-[12px] font-medium">
                          Sale Price
                        </th>
                      ) : (
                        ""
                      )}
                      <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                        Discount
                      </th>
                      <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                        Tax
                      </th>
                      <th className="w-[14%] table-head uppercase text-[12px] font-medium">
                        Amount (₹)
                      </th>
                      <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          <PlusCircleFilled className="text-[30px] text-[#8b8787]" />
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      itemSelectedRows.map((data, index) => {
                        const taxFinalValue = data.quantityCount
                          ? parseFloat(data.taxValue).toFixed(2)
                          : parseFloat(data.taxValue).toFixed(2);
                        return (
                          <tr
                            key={index}
                            className="table-purchase-orders-row p-2"
                          >
                            <td className="table-data font-medium text-center">
                              {index + 1}
                            </td>
                            <td className="table-data font-semibold font-medium text-start">
                              {data.itemName}

                              {/* <Input
                                name="itemDescription"
                                value={data.itemDescription}
                                className="p-2 mt-[3px] h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="Enter Description (optional)"
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "itemDescription",
                                    index
                                  )
                                }
                              /> */}
                            </td>
                            <td className="table-data font-medium text-start">
                              <Select
                                name="ramId"
                                value={data.ramId}
                                options={ramListOptions}
                                onChange={(e) =>
                                  itemSelectedChange(e, "ramId", index)
                                }
                                suffixIcon={
                                  data.ramId ? (
                                    <CloseCircleOutlined
                                    // onClick={() => {
                                    //   data.ramId = "";
                                    //   data.ramName = "";
                                    // }}
                                    />
                                  ) : (
                                    <DownOutlined />
                                  )
                                }
                                allowClear
                                className="h-[40px] w-[100%] border-none hover:bg-[#e9ecf1]"
                                placeholder="Select Ram"
                              />
                            </td>
                            {/* {purchaseData.travel === true ? (
                              <td className="table-data font-medium text-center">
                                {data.travel ? data.travel : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.batch === true ? (
                              <td className="table-data font-medium text-center">
                                {data.batch ? data.batch : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.expiryDate === true ? (
                              <td className="table-data font-medium text-center">
                                {data.expiryDate ? data.expiryDate : "--"}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.mfgDate === true ? (
                              <td className="table-data font-medium text-center">
                                {data.mfgDate ? data.mfgDate : "--"}
                              </td>
                            ) : (
                              ""
                            )}*/}
                            {purchaseData.quantity === true ? (
                              <td className="table-data font-medium text-start">
                                <Input
                                  name="quantityCount"
                                  value={data.quantityCount}
                                  className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                  placeholder="Enter Qty (optional)"
                                  onChange={(e) =>
                                    itemSelectedChange(
                                      e,
                                      "quantityCount",
                                      index
                                    )
                                  }
                                  style={{
                                    textAlign: "end",
                                  }}
                                  suffix={"PCS"}
                                />{" "}
                                {/* PCS */}
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.price === true ? (
                              <td className="table-data font-medium text-center">
                                <Input
                                  name="purchasePrice"
                                  value={data.purchasePrice}
                                  prefix={"₹"}
                                  className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                  placeholder="Enter price"
                                  onChange={(e) =>
                                    itemSelectedChange(
                                      e,
                                      "purchasePrice",
                                      index
                                    )
                                  }
                                  style={{
                                    textAlign: "right",
                                  }}
                                />
                              </td>
                            ) : (
                              ""
                            )}
                            {purchaseData.sellingPrice === true ? (
                              <td className="table-data font-medium text-center">
                                <Input
                                  name="salesPrice"
                                  value={data.salesPrice}
                                  prefix={"₹"}
                                  className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                  placeholder="Enter price"
                                  onChange={(e) =>
                                    itemSelectedChange(e, "salesPrice", index)
                                  }
                                  style={{
                                    textAlign: "right",
                                  }}
                                />
                              </td>
                            ) : (
                              ""
                            )}
                            <td className="table-data font-medium">
                              <Input
                                name="discountPercentage"
                                suffix={"%"}
                                value={data.discountPercentage}
                                className="p-2 mb-1 h-[30px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="%"
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "discountPercentage",
                                    index
                                  )
                                }
                              />

                              <Input
                                name="discountPrice"
                                value={data.discountPrice}
                                className="p-2 h-[30px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="price"
                                prefix={"₹"}
                                onChange={(e) =>
                                  itemSelectedChange(e, "discountPrice", index)
                                }
                              />
                            </td>
                            <td className="table-data font-medium">
                              <Select
                                name="taxPercentageId"
                                value={data.taxPercentageId}
                                options={
                                  recordsMetaData
                                    ? recordsMetaData.gstPercentageOptions
                                    : []
                                }
                                onChange={(e) =>
                                  itemSelectedChange(
                                    e,
                                    "taxPercentageId",
                                    index
                                  )
                                }
                                className="h-[40px] w-[90%] border-none hover:bg-[#e9ecf1]"
                                placeholder="% 0"
                              />
                              <p className="text-center mt-1">
                                {data.taxValue ? `(₹ ${taxFinalValue})` : ""}
                              </p>
                            </td>
                            <td className="table-data font-medium text-center">
                              <Input
                                name="totalAmount"
                                value={data.totalAmount}
                                className="p-2 h-[35px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                placeholder="Enter price"
                                prefix={"₹"}
                                onChange={(e) =>
                                  itemSelectedChange(e, "totalAmount", index)
                                }
                              />
                            </td>
                            <td className="table-data font-medium text-center">
                              <DeleteOutlined
                                onClick={() => removeItemsData(index)}
                                type="primary"
                                className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                                size={"large"}
                              />
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={0}>
                        <td colSpan={11} className="text-center">
                          {/* No Data Found */}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
              <Col span={24} className="mt-2">
                <Row>
                  <Col md={18} lg={18} xl={18} xxl={18} sm={24} xs={24}>
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(false);
                        dispatch(loadCategory(purchaseList));
                        dispatch(loadItems(purchaseList));
                        dispatch(loadPurchaseRecordsMetaData());

                        // setItemSelectedRows([
                        //   {
                        //     itemName: "",
                        //     itemChecked: "",
                        //     itemNameValue: "",
                        //     taxPercentageValue: "",
                        //     itemDescription: "",
                        //     itemCode: "",
                        //     salesPrice: "",
                        //     purchasePrice: "",
                        //     ramId: "",
                        //     ramName: "",
                        //     discountPrice: "",
                        //     discountPercentage: "",
                        //     taxPercentage: "",
                        //     taxValue: "",
                        //     taxPercentageId: "",
                        //     taxPercentageName: "",
                        //     totalAmount: "",
                        //     hsnCode: "",
                        //     categoryId: "",
                        //     categoryName: "",
                        //     stockQTY: "",
                        //     quantityCount: "",
                        //     batchDetails: "",
                        //     createdAt: "",
                        //     createdBy: "",
                        //     customFields: "",
                        //     image: "",
                        //     isProduct: "",
                        //     isService: "",
                        //     measuringId: "",
                        //     serialDetails: "",
                        //     itemUpdateId: "",
                        //     serialMeasuringId: "",
                        //     updatedAt: "",
                        //     _id: "",
                        //     index: "",
                        //     action: "",
                        //     status: "",
                        //   },
                        // ]);
                      }}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="text-center text-[#488dff] cursor-pointer border border-dashed border-1 border-blue-400 pt-3 pb-3 pl-10 pr-10"
                    >
                      <PlusOutlined /> Add Item
                    </div>
                  </Col>
                  <Col
                    md={6}
                    lg={6}
                    xl={6}
                    xxl={6}
                    sm={24}
                    xs={24}
                    className={media == "sm" || media == "xs" ? "mt-2" : "pl-4"}
                  >
                    <div
                      onClick={() => {
                        setItemModal(true);
                        setScanQrModal(true);
                      }}
                      style={{
                        pointerEvents: "none",
                        opacity: 2,
                        cursor: "not-allowed",
                      }}
                      className={
                        media == "sm" || media == "xs"
                          ? "cursor-pointer flex justify-center border border-1 pt-2 pb-2 pl-5 pr-5 bg-[lightgray]"
                          : // ? "cursor-pointer flex justify-center border border-1 pt-2 pb-2 pl-5 pr-5"
                            "cursor-pointer flex border border-1 pt-2 pb-2 pl-5 pr-5 bg-[lightgray]"
                      }
                    >
                      <PiBarcodeBold
                        size={
                          media == "sm" || media == "xs" || media == "md"
                            ? ""
                            : 30
                        }
                        className="mr-2"
                      />
                      <h1
                        className={
                          media == "sm" || media == "xs" || media == "md"
                            ? "purchase-label text-[14px] font-medium"
                            : "purchase-label text-[18px] mt-2 font-medium"
                        }
                      >
                        Scan Barcode
                      </h1>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            {/* Total section */}
            <Row className="bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3">
              <Col
                md={14}
                lg={14}
                xl={14}
                xxl={14}
                sm={24}
                xs={24}
                className={
                  media == "sm" || media == "xs"
                    ? "flex justify-center w-[100%] border border-b-1 border-t-0 border-x-0 pb-2"
                    : "flex justify-end"
                }
              >
                <div className="flex">
                  <h1
                    className={
                      media == "sm" || media == "xs"
                        ? "text-[14px] pr-2 purchase-label font-semibold"
                        : "text-[14px] pr-2 text-end purchase-label font-semibold"
                    }
                  >
                    SUB-Total
                  </h1>
                  {media === "sm" || media === "xs" ? (
                    ""
                  ) : (
                    <Divider
                      type={"vertical"}
                      className="total-purchase-orders-divider"
                    />
                  )}
                  {/* {media == "sm" || media == 'xs' ? "" : <Divider
                    // className="w-[110%] ml-[-24px]"
                    type={"vertical"}
                    className="total-purchase-orders-divider"
                  />} */}
                </div>
              </Col>
              <Col md={3} lg={3} xl={3} xxl={3} sm={24} xs={24}>
                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "flex justify-center w-[100%] border border-b-1 border-t-0 border-x-0 pt-2 pb-2"
                      : "flex"
                  }
                >
                  <div className="flex">
                    <p className="text-[14px] pr-2 font-semibold">₹</p>
                    <h1 className="text-[14px] pr-2 text-end purchase-label font-semibold">
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? totals.discountPrice &&
                          totals.discountPrice.toFixed(2)
                        : // : itemSelectedRows.length > 1
                          // ? discountPriceTotal
                          0}
                      {/* ₹ {0} */}
                    </h1>
                  </div>
                  {media === "sm" || media === "xs" ? (
                    ""
                  ) : (
                    <Divider
                      type={"vertical"}
                      className="total-purchase-orders-divider"
                    />
                  )}
                </div>
              </Col>
              <Col md={3} lg={3} xl={3} xxl={3} sm={24} xs={24}>
                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "flex justify-center w-[100%] border border-b-1 border-t-0 border-x-0 pt-2 pb-2"
                      : "flex"
                  }
                >
                  <div className="flex">
                    <p className="text-[14px] pr-2 font-semibold">₹</p>
                    <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                      {itemSelectedRows && itemSelectedRows.length > 0
                        ? totals.taxValue && totals.taxValue.toFixed(2)
                        : // : itemSelectedRows.length > 1
                          // ? taxValueTotal
                          0}
                      {/* ₹ {taxValueTotal} */}
                    </h1>
                  </div>
                  {media === "sm" || media === "xs" ? (
                    ""
                  ) : (
                    <Divider
                      type={"vertical"}
                      className="total-purchase-orders-divider"
                    />
                  )}
                </div>
              </Col>
              <Col md={4} lg={4} xl={4} xxl={4} sm={24} xs={24}>
                <div
                  className={
                    media == "sm" || media == "xs"
                      ? "flex justify-center pt-2"
                      : "flex"
                  }
                >
                  <p className="text-[14px] pr-2 font-semibold">₹</p>
                  <h1 className="text-[14px] pr-2 purchase-label font-semibold">
                    {itemSelectedRows && itemSelectedRows.length > 0
                      ? totals.totalAmount && totals.totalAmount.toFixed(2)
                      : // : itemSelectedRows.length > 1
                        // ? selectedItemsTotal
                        0}
                    {/* ₹ {selectedItemsTotal} */}
                  </h1>
                </div>
              </Col>
            </Row>

            {/* Add notes, total section */}
            <Row className="border border-x-0 border-t-0 border-b-1">
              <Col
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                sm={24}
                xs={24}
                className={
                  media === "sm" || media === "xs"
                    ? "border border-x-1 border-b-1 border-t-0"
                    : "border border-r-1 border-l-0 border-y-0"
                }
              >
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  {notesOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Notes
                        <CloseCircleOutlined
                          onClick={() => setNotesOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        placeholder="Enter your notes"
                        className="p-2 h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setNotesOpen(true)}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="mb-3 purchase-label text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Notes
                    </div>
                  )}
                  {termsOpen === true ? (
                    <div className="mt-3">
                      <Typography className="input-label mb-1 flex justify-between">
                        Terms and Conditions{" "}
                        <CloseCircleOutlined
                          onClick={() => setTermsOpen(false)}
                        />
                      </Typography>
                      <Input.TextArea
                        name="termsConditions"
                        value={termsConditions}
                        onChange={(e) => setTermsConditions(e.target.value)}
                        placeholder="Enter your terms & conditions"
                        className="p-3 h-[35px] purchase-label bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        fontFamily: "Poppins",
                      }}
                      onClick={() => setTermsOpen(true)}
                      className="mt-3 purchase-label text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Terms and Conditions
                    </div>
                  )}
                </div>
              </Col>
              <Col
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                sm={24}
                xs={24}
                className="border border-r-1 border-l-0 border-y-0"
              >
                {/* Total , after gst section */}
                {discount === "Display Before Tax" ? (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => {
                            handlePurchaseChange(e);
                          }}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2 text-[16px] pt-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          onClick={() => setDiscountOpen(true)}
                        >
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice
                              : // : itemSelectedRows.length > 1
                                // ? discountPriceTotal
                                0}
                          </h1>
                        </div>
                      </div>
                    )}

                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          // addonAfter={
                          //   <Select
                          //     value={additionalOptions}
                          //     onChange={(e) => setAdditionalOptions(e)}
                          //     style={{
                          //       width: "160px",
                          //       height: 25,
                          //     }}
                          //     defaultValue={"No Tax Applicable"}
                          //     options={[
                          //       {
                          //         value: "No Tax Applicable",
                          //         label: "No Tax Applicable",
                          //       },
                          //     ]}
                          //   />
                          // }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                        >
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                    {/* <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-4 flex justify-between mb-3 cursor-pointer"
                    >
                      <h1 className="text-[14px] purchase-label">
                        Taxable Amount
                      </h1>
                      <p className="text-[15px] flex font-semibold">
                        ₹{" "}
                        <p className="purchase-label text-[14px] ml-1 mt-[1.5px]">
                          {" "}
                          {itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          itemSelectedRows.length == 1
                            ? itemSelectedRows[0].salesPrice
                            : itemSelectedRows.length > 1
                            ? totals.salesPrice
                            : 0}{" "}
                        </p>
                      </p>
                    </div> */}
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      <>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-1 cursor-pointer"
                        >
                          {commonTaxes && commonTaxes.length > 0
                            ? commonTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mb-3 cursor-pointer"
                        >
                          {uniqueTaxes && uniqueTaxes.length > 0
                            ? uniqueTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-1 cursor-pointer"
                        >
                          {commonTaxes && commonTaxes.length > 0
                            ? commonTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      CGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mb-3 cursor-pointer"
                        >
                          {uniqueTaxes && uniqueTaxes.length > 0
                            ? uniqueTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;

                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;

                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      CGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div className="p-6 border border-x-0 border-b-1 border-t-0">
                    {additionalChargesOpen === true ? (
                      <div className="w-[100%] flex mt-3">
                        <Input
                          name="chargesData"
                          value={totalSectionData.chargesData}
                          placeholder="Enter charge(eg: transport charge)"
                          onChange={(e) => handlePurchaseChange(e)}
                          className="w-[60%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                        />
                        <Input
                          name="additionalCharges"
                          value={totalSectionData.additionalCharges}
                          onChange={(e) => handlePurchaseChange(e)}
                          // addonAfter={
                          //   <Select
                          //     value={additionalOptions}
                          //     onChange={(e) => setAdditionalOptions(e)}
                          //     style={{
                          //       width: "160px",
                          //       height: 25,
                          //     }}
                          //     defaultValue={"No Tax Applicable"}
                          //     options={[
                          //       {
                          //         value: "No Tax Applicable",
                          //         label: "No Tax Applicable",
                          //       },
                          //     ]}
                          //   />
                          // }
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[90%] pr-3 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[10%] pl-3"
                          onClick={() => setAdditionalChargesOpen(false)}
                        />
                      </div>
                    ) : (
                      <div
                        onClick={() => setAdditionalChargesOpen(true)}
                        className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                        >
                          <PlusOutlined /> Add Additional Charges
                        </div>
                        <div>
                          <h1>
                            ₹.
                            {totalSectionData.additionalCharges
                              ? totalSectionData.additionalCharges
                              : 0}
                          </h1>
                        </div>
                      </div>
                    )}
                    {/* <div
                      // onClick={() => setAdditionalChargesOpen(true)}
                      className="mt-4 flex justify-between mb-3 cursor-pointer"
                    >
                      <h1 className="text-[14px] purchase-label">
                        Taxable Amount
                      </h1>
                      <p className="text-[15px] flex font-semibold">
                        ₹{" "}
                        <p className="purchase-label text-[14px] ml-1 mt-[1.5px]">
                          {" "}
                          {itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          itemSelectedRows.length == 1
                            ? itemSelectedRows[0].salesPrice
                            : itemSelectedRows.length > 1
                            ? totals.salesPrice
                            : 0}{" "}
                        </p>
                      </p>
                    </div> */}
                    {itemSelectedRows &&
                    itemSelectedRows.length > 0 &&
                    !isEmpty(itemSelectedRows[0].itemName) ? (
                      <>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-1 cursor-pointer"
                        >
                          {commonTaxes && commonTaxes.length > 0
                            ? commonTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mb-3 cursor-pointer"
                        >
                          {uniqueTaxes && uniqueTaxes.length > 0
                            ? uniqueTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      SGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mt-4 mb-1 cursor-pointer"
                        >
                          {commonTaxes && commonTaxes.length > 0
                            ? commonTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;
                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;
                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      CGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                        <div
                          // onClick={() => setAdditionalChargesOpen(true)}
                          className="mb-3 cursor-pointer"
                        >
                          {uniqueTaxes && uniqueTaxes.length > 0
                            ? uniqueTaxes.map((data) => {
                                const percentageValue = !isNaN(data.tax)
                                  ? parseFloat(data.tax)
                                  : 0;

                                const percentageIndividual =
                                  percentageValue / 2;

                                const tavValueFinal =
                                  parseFloat(data.totalSum) / 2;

                                return (
                                  <div className="flex justify-between">
                                    <h1 className="purchase-label text-[14px]">
                                      CGST @{percentageIndividual}
                                    </h1>
                                    <p className="text-[15px] flex font-semibold">
                                      ₹{" "}
                                      <p className="purchase-label ml-1 mt-[1.5px] text-[14px]">
                                        {data.totalSum
                                          ? tavValueFinal.toFixed(2)
                                          : 0}
                                      </p>
                                    </p>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {discountOpen === true ? (
                      <div className="w-[100%] flex mt-4">
                        <Select
                          value={discount}
                          onChange={(e) => setDiscount(e)}
                          style={{
                            width: "50%",
                            height: 35,
                          }}
                          defaultValue={"Display After Tax"}
                          options={[
                            {
                              value: "Display Before Tax",
                              label: "Display Before Tax",
                            },
                            {
                              value: "Display After Tax",
                              label: "Display After Tax",
                            },
                          ]}
                        />
                        <Tooltip
                          title="Invoice discount will be split among items in the ratio of taxable amount"
                          placement="top"
                        >
                          <InfoCircleOutlined className="ml-3 16px mr-3" />
                        </Tooltip>
                        <Input
                          name="discountPercent"
                          value={totalSectionData.discountPercent}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"% "}
                          placeholder="0"
                          className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <p className="pr-2 pl-2">{" / "}</p>
                        <Input
                          name="discountAmount"
                          value={totalSectionData.discountAmount}
                          onChange={(e) => handlePurchaseChange(e)}
                          type="text"
                          prefix={"₹ "}
                          placeholder="0"
                          className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[25px]"
                        />
                        <CloseCircleOutlined
                          className="w-[15%] pl-5"
                          onClick={() => setDiscountOpen(false)}
                        />
                      </div>
                    ) : (
                      <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          onClick={() => setDiscountOpen(true)}
                        >
                          <PlusOutlined /> Add Discount
                        </div>
                        <div>
                          <h1>
                            -₹.{" "}
                            {itemSelectedRows && itemSelectedRows.length > 0
                              ? totals.discountPrice
                              : // : itemSelectedRows.length > 1
                                // ? discountPriceTotal
                                0}
                          </h1>
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div className="p-6 border border-x-0 border-b-1 border-t-0">
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="w-[100%] mt-2 purchase-label flex justify-between mb-3 cursor-pointer"
                  >
                    <Checkbox
                      type="checkbox"
                      name="autoRoundfOff"
                      height={14}
                      width={14}
                      // defaultChecked
                      checked={autoRoundOff}
                      value={autoRoundOff}
                      onChange={(e) => {
                        setAutoRoundOff(e.target.checked);

                        setTotalSectionData({
                          ...totalSectionData,
                          autoRoundOffValue: 0,
                        });
                      }}
                      className="w-[50%] text-[#084d7b]"
                    >
                      <p
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className={autoRoundOff === false ? "mt-2" : "mt-2"}
                      >
                        {" "}
                        Auto Round Off{" "}
                      </p>
                    </Checkbox>
                    {/* {autoRoundOff === false ? ( */}
                    <Input
                      name="autoRoundOffValue"
                      value={totalSectionData.autoRoundOffValue}
                      onChange={(e) => handlePurchaseChange(e)}
                      disabled={autoRoundOff === true ? false : true}
                      addonBefore={
                        <Select
                          value={autoRoundOffMethod}
                          disabled={autoRoundOff === true ? false : true}
                          onChange={(e, options) =>
                            setAutoRoundOffMethod({
                              value: e,
                              label: options.label,
                            })
                          }
                          style={{
                            width: 110,
                            height: 25,
                          }}
                          options={[
                            {
                              value: "add",
                              label: "+ Add",
                            },
                            {
                              value: "reduce",
                              label: "- Reduce",
                            },
                          ]}
                        />
                      }
                      type="text"
                      prefix={"₹ "}
                      placeholder="0"
                      className="w-[50%] mb-3 h-[25px]"
                    />
                    {/* ) : (
                      ""
                    )} */}
                  </div>
                  <div
                    // onClick={() => setAdditionalChargesOpen(true)}
                    className="mt-5 font-semibold flex justify-between mb-3 cursor-pointer"
                  >
                    <h1 className="w-[50%] purchase-label text-[14px] mt-1">
                      Total Amount
                    </h1>
                    <h1 className="text-[16px]">
                      ₹.{" "}
                      {itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      autoRoundOff
                        ? Math.round(netAmount)
                        : itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          !autoRoundOff
                        ? netAmount && netAmount.toFixed(2)
                        : 0}
                    </h1>
                    {/* <Input
                      name="totalAmount"
                      value={totalSectionData.totalAmount}
                      onChange={(e) => handlePurchaseChange(e)}
                      type="text"
                      prefix={"₹ "}
                      placeholder="Enter Payment Amount"
                      className="w-[50%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] h-[25px]"
                    /> */}
                  </div>
                </div>
                <div
                  // onClick={() => setAdditionalChargesOpen(true)}
                  className="mt-3 p-3 text-[14px] mb-2 purchase-label mb-3 cursor-pointer"
                >
                  <div className="flex justify-end">
                    <h1>Authorized signatory for</h1>
                    <p className="font-semibold ml-2">{organizationName}</p>
                  </div>
                  <div className="flex justify-end mt-2 mb-2 ml-10">
                    <Upload
                      // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                      listType="picture-card"
                      // fileList={fileList}
                      accept=".png, .jpeg"
                      maxCount={1}
                      onPreview={handlePreview}
                      onChange={handleImageChange}
                      showUploadList={{
                        showDownloadIcon: true,
                        showRemoveIcon: false,
                      }}
                      beforeUpload={() => false}
                      onRemove={false}
                    >
                      {fileList.length >= 1 ? null : uploadButton}
                    </Upload>
                    {isEmpty(previewImage) &&
                    !isEmpty(updatedData) &&
                    updatedData._id ? (
                      <Image src={updatePreviewImage} height={50} width={100} />
                    ) : (
                      !isEmpty && (
                        <Image
                          wrapperStyle={{
                            display: "none",
                          }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </div>

        {/* Custom fields modal */}
        <Modal
          open={columnSettings}
          title="Show/Hide Columns in Invoice"
          onOk={() => setColumnSettings(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          className="mt-[-70px]"
          onCancel={() => setColumnSettings(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            // className="w-[110%] ml-[-24px]"
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-3px",
            }}
          />
          <Col className="mb-3">
            <div className="purchase-label flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Column Name</h1>
              <p>Show</p>
            </div>

            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Price/ Item(₹)</h1>
              <Switch
                value={purchaseData.price}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    price: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Quantity</h1>
              <Switch
                value={purchaseData.quantity}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    quantity: checked,
                  })
                }
              />
            </div>
            <div className="purchase-label mt-[-5px] flex uppercase text-[12px] bg-[#cdcccc63] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between">
              <h1 className="">Custom Column Name</h1>
              <p>Show</p>
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Travel</h1>
              <Switch
                value={purchaseData.travel}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    travel: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Batch No</h1>
              <Switch
                value={""}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    batch: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>Expiry Date</h1>
              <Switch
                value={purchaseData.expiryDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    expiryDate: checked,
                  })
                }
              />
            </div>
            <div
              className={
                "purchase-label flex text-[12px] bg-[white] mb-1 p-2 border border-b-1 border-x-0 border-t-0 justify-between"
              }
            >
              <h1>mfgDate</h1>
              <Switch
                value={purchaseData.mfgDate}
                onChange={(checked) =>
                  setPurchaseData({
                    ...purchaseData,
                    mfgDate: checked,
                  })
                }
              />
            </div>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 flex bg-[#ffb8001a] purchase-label text-[10px] terms-conditions-card mb-3 mt-1 pr-3"
          >
            <h1 className="flex font-bold ml-10">
              <p className="flex font-medium ml-2">
                To add Custom Item Columns - Go to Item settings from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Items page (click here)
                </p>
              </p>
            </h1>
          </Col>
        </Modal>
        {/* settings Field Modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Purchase Invoice Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Purchase Invoice Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1 purchase-label">
                    Prefix
                  </Typography>

                  <Input
                    name="prefix"
                    value={purchaseSettings.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(purchaseSettings.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography className="mb-1 purchase-label">
                    Sequence Number
                  </Typography>

                  <Input
                    name="seqNo"
                    value={purchaseSettings.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(purchaseSettings.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1 purchase-label">
                    Purchase Invoice Number:{" "}
                    {purchaseSettings.prefix
                      ? purchaseSettings.prefix + "" + purchaseSettings.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createPartyModal}
          title={
            partyMode === "Update" ? "Update New Vendor" : "Create New Vendor"
          }
          onOk={() => {
            if (partyMode === "Update") {
              updateVendorApi();
            } else {
              createVendorApi();
            }
          }}
          closeIcon
          maskClosable={false}
          okText={partyMode === "Update" ? "Update" : "Save"}
          width={600}
          okButtonProps={{
            disabled: isVendorButtonDisabled ? true : false,
          }}
          className="mt-[-70px]"
          onCancel={() => setCreatePartyModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <Row className="mt-2 mb-2">
              <Col span={24} className="">
                <Typography className="text-[gray] input-required-label uppercase flex">
                  Vendor Name <p className="text-[red]">*</p>
                </Typography>
                <Input
                  name="vendorName"
                  value={partyModalData.vendorName}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter name"
                  className="p-2"
                />
                <p className="text-start text-[red] mt-2 mb-3">
                  {addressValidations == true &&
                  isEmpty(partyModalData.vendorName)
                    ? "The vendor name field is required"
                    : ""}
                </p>
              </Col>
              <Col span={24} className="mt-2">
                <Typography className="text-[gray] input-label mb-1 uppercase">
                  Mobile Number
                </Typography>
                <Input
                  name="mobile"
                  value={partyModalData.mobile}
                  onChange={(e) => handleModalChange(e)}
                  placeholder="Enter Mobile No"
                  maxLength={10}
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mt-3">
                <div className="">
                  {addAddressShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add Address</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddAddressShow(false)}
                        >
                          Remove
                        </p>
                      </Col>
                      <Col span={24} className="mt-3">
                        <Typography className="text-[gray] flex input-required-label uppercase">
                          Billing Address
                          <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Input.TextArea
                          name="billingAddress"
                          value={partyModalData.billingAddress}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter Billing Address"
                          className="p-3 h-[35px]"
                        />
                        <p className="text-start text-[red] mt-2 mb-3">
                          {addressValidations == true &&
                          isEmpty(partyModalData.billingAddress)
                            ? "The billing address field is required"
                            : ""}
                        </p>
                      </Col>
                      <Col span={12} className="mt-2 pr-3">
                        <Typography className="text-[gray] input-required-label uppercase mb-1">
                          State <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Select
                          style={{
                            width: 250,
                            height: 40,
                          }}
                          value={stateData}
                          onChange={(e) => setStateData(e)}
                          placeholder="Select State"
                          options={
                            recordsMetaData ? recordsMetaData.stateOptions : []
                          }
                        />
                        <p className="text-start text-[red] mt-2 mb-3">
                          {addressValidations == true && isEmpty(stateData)
                            ? "The state field is required"
                            : ""}
                        </p>
                      </Col>
                      <Col span={12} className="mt-2 pl-3">
                        <Typography className="text-[gray] input-required-label uppercase mb-1">
                          Pincode <p className="text-[#df121c]">*</p>
                        </Typography>
                        <Input
                          name="pincode"
                          value={pincode}
                          onChange={(e) => {
                            const name = "pincode";
                            const validationRules = {
                              pincode: /^[0-9]*$/,
                            };
                            if (validationRules[name]) {
                              if (
                                validationRules[name].test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                setPincode(e.target.value);
                              }
                            }

                            axios
                              .get(
                                `https://api.postalpincode.in/pincode/${e.target.value}`
                              )
                              .then((res) => {
                                if (e.target.value.length === 6) {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName:
                                      res &&
                                      res.data &&
                                      res.data.length > 0 &&
                                      res.data[0].PostOffice !== null
                                        ? res.data[0].PostOffice[0].District
                                        : "",
                                  });
                                } else {
                                  setPartyModalData({
                                    ...partyModalData,
                                    cityName: "",
                                  });
                                }
                              });
                          }}
                          maxLength={6}
                          placeholder="Enter pincode"
                          className="p-2 text-semibold"
                        />
                        <p className="text-start text-[red] mt-2 mb-3">
                          {addressValidations == true && isEmpty(pincode)
                            ? "The pincode field is required"
                            : ""}
                        </p>
                      </Col>
                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          City
                        </Typography>
                        <Input
                          name="cityName"
                          value={partyModalData.cityName}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter City"
                          className="p-2 text-semibold"
                        />
                      </Col>
                      <Col span={24} className="mt-3 mb-1">
                        <div className="flex">
                          <Checkbox
                            type="checkbox"
                            name="sameAs"
                            height={14}
                            width={14}
                            defaultChecked
                            value={sameAs}
                            onChange={(e) => setSameAs(e.target.checked)}
                            className="text-[#084d7b]"
                          >
                            Same as Billing Address
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddAddressShow(true)}
                      className="mb-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add Address
                      {/* (Optional) */}
                    </div>
                  )}
                  {addGstShow === true ? (
                    <Row>
                      <Col
                        span={24}
                        className="mt-2 bg-[#f3f3f3] rounded-md p-2 flex justify-between cursor-pointer"
                      >
                        <h1>Add GST (Optional)</h1>
                        <p
                          className="text-[#df121c]"
                          onClick={() => setAddGstShow(false)}
                        >
                          Remove
                        </p>
                      </Col>

                      <Col span={24} className="mt-2">
                        <Typography className="text-[gray] input-label uppercase">
                          GSTIN
                        </Typography>
                        <Input
                          name="gstIn"
                          value={partyModalData.gstIn}
                          onChange={(e) => handleModalChange(e)}
                          placeholder="Enter gstIn"
                          className="p-2 text-semibold"
                        />
                      </Col>
                    </Row>
                  ) : (
                    <div
                      onClick={() => setAddGstShow(true)}
                      className="mt-3 text-[#488dff] cursor-pointer"
                    >
                      <PlusOutlined /> Add GSTIN (Optional)
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            span={24}
            className="mt-3 mb-2 bg-[#ffb8001a] purchase-label text-[12px] terms-conditions-card pr-3"
          >
            <h1 className="flex justify-center font-bold ml-15">
              <p className="flex font-medium ml-2">
                You can add Custom Fields from
                <p className="cursor-pointer flex ml-1 text-[blue]">
                  Party settings
                </p>
              </p>
            </h1>
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "109%", marginLeft: "-24px" }}
          />
        </Modal>

        {/* create party modal */}

        <Modal
          open={createShippingModal}
          title={"Change Shipping Address"}
          onOk={() => {
            setCreateShippingModal(false);
            if (partyCheckedId) {
              toast.success("Shipping address selected successfully");
            }
          }}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setCreateShippingModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mt-[-8px]">
            <Row
              style={{
                fontFamily: "Poppins",
                borderBottomWidth: "0.1px",
                width: "108.5%",
                marginLeft: "-24px",
              }}
              className="text-[12px] font-semobild p-2"
            >
              <Col
                style={{ fontFamily: "Poppins", paddingLeft: "10px" }}
                span={16}
              >
                Address
              </Col>
              <Col style={{ fontFamily: "Poppins" }} span={6}>
                Edit
              </Col>
              <Col style={{ fontFamily: "Poppins" }} span={2}>
                Select
              </Col>
            </Row>
            <>
              {partyAddressData &&
              partyAddressData.length > 0 &&
              partyAddressData[0].address1 ? (
                partyAddressData.map((data, index) => {
                  const address =
                    data.address1 +
                    " " +
                    data.city +
                    ", " +
                    data.stateName +
                    ", " +
                    data.pincode;

                  return (
                    <Row
                      key={index}
                      style={{
                        borderBottomWidth: "0.1px",
                        width: "108.5%",
                        marginLeft: "-24px",
                      }}
                      className="text-[12px] font-semobild p-2"
                    >
                      <Col span={16} className="pl-2">
                        {address ? address : ""}
                      </Col>
                      <Col span={6}>
                        <EditOutlined
                          className="text-[18px]"
                          onClick={() => {
                            setCreateNewShippingModal(true);
                            setNewShippingData({
                              ...newShippingData,
                              _id: data._id,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                            setShippingPincode(data.pincode);
                            setShippingState(data.stateName);
                          }}
                        />
                      </Col>
                      <Col span={2}>
                        <Radio
                          onClick={() => {
                            setPartyCheckedId(data._id);

                            setPartyModalData({
                              ...partyModalData,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                            setNewShippingData({
                              ...newShippingData,
                              cityName: data.city,
                              billingAddress: data.address1,
                              state: data.state,
                              totalAddress: address,
                            });
                          }}
                          checked={partyCheckedId == data._id ? true : false}
                          onChange={(e) => {
                            setPartyCheckedId(data._id);
                            if (e.target.checked) {
                              setPartyModalData({
                                ...partyModalData,
                                cityName: data.city,
                                billingAddress: data.address1,
                                state: data.state,
                                totalAddress: address,
                              });
                              setNewShippingData({
                                ...newShippingData,
                                cityName: data.city,
                                billingAddress: data.address1,
                                state: data.state,
                                totalAddress: address,
                              });
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  );
                })
              ) : (
                <Row className="text-center">No data found</Row>
              )}
            </>
          </Col>
          <Col
            span={24}
            className="mt-1 mb-2 text-[#4096ff] purchase-label text-[12px] purchase-terms-conditions-card pr-3"
          >
            <h1
              onClick={() => {
                setCreateNewShippingModal(true);
                setNewShippingData({
                  ...newShippingData,
                  _id: "",
                  cityName: "",
                  billingAddress: "",
                  state: "",
                  totalAddress: "",
                });
                setShippingPincode("");
                setShippingState([]);
              }}
              className="flex cursor-pointer font-semibold text-[12px]"
            >
              + Add New Shipping Address
            </h1>
          </Col>
          <Divider
            style={{
              borderWidth: "0.2px",
              marginBottom: "2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Billing modal */}
        <Modal
          open={createNewShippingModal}
          title={
            !isEmpty(newShippingData._id)
              ? "Update Shipping Address"
              : "Add Shipping Address"
          }
          closeIcon
          maskClosable={false}
          okText={!isEmpty(newShippingData._id) ? "Update" : "Save"}
          onClose={() => setCreateNewShippingModal(false)}
          onCancel={() => setCreateNewShippingModal(false)}
          onOk={
            !isEmpty(newShippingData._id)
              ? billingAddressUpdate
              : billingAddressSubmit
          }
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
          width={600}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />

          <Row>
            <Col span={24}>
              <Typography className="parties-input-required-label">
                Street Address <p className="text-[red] mx-1">*</p>
              </Typography>
              <Input.TextArea
                name="billingAddress"
                value={newShippingData.billingAddress}
                onChange={(e) => handleShippingModalChange(e)}
                placeholder="Enter Street Address"
                className="pt-2 pb-5 text-semibold"
              />
            </Col>
            <Col span={12} className="mt-1">
              <Typography className="parties-input-required-label">
                State<p className="text-[red] mx-1">*</p>
              </Typography>
              <Select
                style={{
                  width: 250,
                  height: 40,
                }}
                value={shippingState}
                onChange={(e) => setShippingState(e)}
                placeholder="Select State"
                options={recordsMetaData ? recordsMetaData.stateOptions : []}
              />
            </Col>
            <Col span={12} className="mt-2">
              <Typography className="parties-input-required-label">
                Pincode<p className="text-[red] mx-1">*</p>
              </Typography>
              <Input
                name="shippingPincode"
                value={shippingPincode}
                onChange={(e) => {
                  const name = "shippingPincode";
                  const validationRules = {
                    shippingPincode: /^[0-9]*$/,
                  };
                  if (validationRules[name]) {
                    if (
                      validationRules[name].test(e.target.value) ||
                      e.target.value === ""
                    ) {
                      setShippingPincode(e.target.value);
                    }
                  }

                  axios
                    .get(
                      `https://api.postalpincode.in/pincode/${e.target.value}`
                    )
                    .then((res) => {
                      if (e.target.value.length === 6) {
                        setNewShippingData({
                          ...newShippingData,
                          cityName:
                            res &&
                            res.data &&
                            res.data.length > 0 &&
                            res.data[0].PostOffice !== null
                              ? res.data[0].PostOffice[0].District
                              : "",
                        });
                      } else {
                        setNewShippingData({
                          ...newShippingData,
                          cityName: "",
                        });
                      }
                    });
                }}
                maxLength={6}
                placeholder="Enter pincode"
                className="p-2 text-semibold"
              />
            </Col>
            <Col span={24} className="mt-2">
              <Typography className="parties-input-label">City</Typography>
              <Input
                name="cityName"
                value={newShippingData.cityName}
                onChange={(e) => handleShippingModalChange(e)}
                placeholder="Enter City"
                className="p-2 text-semibold"
              />
            </Col>
          </Row>

          <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* item create Modal */}
        <Modal
          open={itemModal}
          title="Add Items"
          onOk={() => {
            setItemModal(false);
            // setPurchaseItemSelect(true);
            // if(itemSelectedRows.length > 0 && itemModal == false) {
            dispatch(loadPurchaseRecordsMetaData());

            // }
          }}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={"80%"}
          className="mt-[-40px]"
          onCancel={() => setItemModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider className="purchase-divider" />
          <Col span={24} className="mt-[-10px]">
            <Row>
              <Col span={8} className="pr-3">
                <AutoComplete
                  style={{
                    width: 170,
                    marginRight: "10px",

                    fontFamily: "Poppins",
                  }}
                >
                  <Input.Search
                    size="large"
                    placeholder="Search Item"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    name="itemSearch"
                    value={itemSearch}
                    onChange={(e) => handleItemSearch(e)}
                  />
                </AutoComplete>
              </Col>
              {scanQrModal === true ? (
                <Col span={6} className="pr-3"></Col>
              ) : (
                <Col span={6} className="pr-3">
                  <Select
                    style={{
                      width: 220,
                      height: 40,
                    }}
                    value={itemCategory}
                    onChange={(e) => {
                      setItemCategory(e);
                      if (!isEmpty(e)) {
                        const filterRows =
                          itemRows.length > 0 &&
                          itemRows.filter((data) => data.categoryId === e);
                        const filteredData =
                          filterRows.length > 0 && filterRows;
                        setItemRows(filteredData);
                      }
                    }}
                    suffixIcon={
                      !isEmpty(itemCategory) ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setItemCategory([]);
                            setItemRows(itemsDataTable);
                          }}
                          className="text-[12px]"
                        />
                      ) : (
                        <SearchOutlined className="text-[12px]" />
                      )
                    }
                    onSearch={true}
                    placeholder="Select Categories"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <div className="w-[100%]">
                          <Button
                            type="dashed"
                            className="w-[100%]"
                            style={{
                              fontFamily: "Poppins",
                            }}
                            icon={<PlusOutlined />}
                            onClick={() => {
                              setItemCategoryModal(true);
                              setCategoryAdditionalFields(false);
                            }}
                          >
                            Add item
                          </Button>
                        </div>
                      </>
                    )}
                    options={categoryOptions}
                  />
                </Col>
              )}

              <Col span={10}>
                {" "}
                <div
                  onClick={() => setCreateItemModal(true)}
                  className="w-[100%] border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                >
                  <PlusOutlined className="mr-1" /> Create New Item
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24} className={"add-create-item-main mt-3"}>
                <table className=" table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Name
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Code
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Sales Price
                      </th>
                      {purchaseColumn === true ? (
                        ""
                      ) : (
                        <th className="table-purchase-head mt-1 flex uppercase text-[12px] font-medium">
                          <h1> Purchase Price </h1>{" "}
                          <CloseCircleOutlined
                            onClick={() => setPurchasePriceModal(true)}
                            className="text-[10px] ml-2 text-[black]"
                          />
                        </th>
                      )}

                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Current Stock
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Quantity
                      </th>

                      {/* <th className="table-head uppercase text-[12px] font-medium">
                        <div
                          className="cursor-pointer"
                          onClick={() => setColumnSettings(true)}
                        >
                          
                        </div>
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {scanQrModal === true ? (
                      <tr key={0} className="text-center">
                        <td
                          colSpan={7}
                          className="cursor-pointer text-center pt-5 pb-5 pl-5 pr-5"
                        >
                          <Image
                            src={qrCodeLogo}
                            preview={false}
                            width={350}
                            height={100}
                          />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {itemRows &&
                        itemRows.length > 0 &&
                        itemRows[0].itemName ? (
                          itemRows.map((data, index) => {
                            const quantitySelected =
                              itemSelectedRows &&
                              itemSelectedRows.length >= 1 &&
                              itemSelectedRows[0].itemId &&
                              itemSelectedRows.find(
                                (item) => item._id == data._id
                              );
                            data.quantityCount =
                              !isEmpty(quantitySelected) &&
                              quantitySelected.quantityCount
                                ? quantitySelected.quantityCount
                                : data.quantityCount;
                            return (
                              <tr
                                key={index}
                                className="table-purchase-orders-row"
                              >
                                <td
                                  className="table-purchase-data flex"
                                  // onClick={() => setExpandable(true)}
                                >
                                  <Checkbox
                                    type="checkbox"
                                    name="itemChecked"
                                    height={14}
                                    width={14}
                                    // defaultChecked
                                    checked={
                                      data.quantityCount !== 0 ||
                                      // ||
                                      itemSelectedRows.some(
                                        (selected) => selected._id == data._id
                                      )
                                    }
                                    value={data.itemChecked}
                                    onChange={(e) =>
                                      handleItemChange(
                                        e,
                                        "itemChecked",
                                        index,
                                        data
                                      )
                                    }
                                    className="mr-2 text-[#084d7b]"
                                  />
                                  <p className="mt-1">{data.itemName}</p>
                                </td>
                                <td className="table-purchase-data">
                                  {data.itemCode}
                                </td>
                                <td className="table-purchase-data">
                                  {data.salesPrice
                                    ? parseFloat(data.salesPrice).toFixed(2)
                                    : // ? parseInt(data.salesPrice).toFixed(2)
                                      ""}
                                </td>
                                {purchaseColumn === true ? (
                                  ""
                                ) : (
                                  <td className="table-purchase-data">
                                    {data.purchasePrice // ? parseInt(data.purchasePrice)
                                      ? parseInt(data.purchasePrice).toFixed(2)
                                      : ""}
                                  </td>
                                )}

                                <td className="uppercase font-semibold table-purchase-data">
                                  {/* {data.itemName === "Fish" ? (
                                    <div
                                      onClick={() => setBatchingModal(true)}
                                      className="w-[100%] border font-medium text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                    >
                                      <PlusOutlined className="mr-1" /> Create
                                      New Batch
                                    </div>
                                  ) : ( */}
                                  {data.stockQTY}
                                  {/* )} */}
                                </td>
                                <td className="table-purchase-data">
                                  {/* {data.stockQTY && data.stockQTY > 1 ? ( */}
                                  <div className="w-[100%] flex justify-between border border-1 text-center rounded-md p-1 cursor-pointer">
                                    <div className="flex">
                                      <p
                                        onClick={() => {
                                          // setQuantityCountValue(
                                          //   quantityCountValue - 1
                                          // );

                                          data.quantityCount = parseInt(
                                            data.quantityCount - 1
                                          );
                                          let newSelecteds = [];
                                          // if (data.quantityCount >= 1) {
                                          // const selectedIndex =
                                          // data.quantityCount == 1 && itemSelectedRows.indexOf(data);
                                          // if (selectedIndex === -1) {
                                          newSelecteds =
                                            data.quantityCount < 1
                                              ? itemSelectedRows.filter(
                                                  (item) =>
                                                    item._id !== data._id
                                                )
                                              : data.quantityCount >= 1 &&
                                                newSelecteds.concat(
                                                  itemSelectedRows,
                                                  data
                                                );

                                          const itemSelectedFilteredRows =
                                            newSelecteds &&
                                            newSelecteds.length > 0
                                              ? newSelecteds.filter(
                                                  (data) =>
                                                    !isEmpty(data.itemName)
                                                )
                                              : [];

                                          const itemSelectedArrays =
                                            newSelecteds &&
                                            itemSelectedFilteredRows &&
                                            itemSelectedFilteredRows.length > 0
                                              ? itemSelectedFilteredRows.map(
                                                  (data, index) => {
                                                    // const gstPercentage =
                                                    //   data.taxPercentageName.replace(
                                                    //     /^%|%$/g,
                                                    //     ""
                                                    //   );
                                                    const totalPriceData =
                                                      !isUndefined(
                                                        data.quantityCount
                                                      ) && data.purchasePrice
                                                        ? data.quantityCount *
                                                          data.purchasePrice
                                                        : isUndefined(
                                                            data.quantityCount
                                                          ) &&
                                                          data.purchasePrice
                                                        ? data.purchasePrice
                                                        : 0;
                                                    const totalSetAmountData =
                                                      data.taxPercentageValue
                                                        ? (totalPriceData *
                                                            data.taxPercentageValue) /
                                                          100
                                                        : data.taxPercentageName
                                                        ? parseFloat(
                                                            totalPriceData *
                                                              data.taxPercentageName
                                                          ) / 100
                                                        : 0;
                                                    const totalPrice =
                                                      totalSetAmountData +
                                                      totalPriceData;

                                                    return {
                                                      index: index + 1,
                                                      itemName: data.itemName,
                                                      itemNameValue:
                                                        data.itemName,
                                                      itemChecked:
                                                        data.quantityCount < 1
                                                          ? false
                                                          : true,
                                                      _id: data._id,
                                                      itemCode: data.itemCode
                                                        ? data.itemCode
                                                        : "--",
                                                      salesPrice:
                                                        data.salesPrice
                                                          ? data.salesPrice
                                                          : "",
                                                      purchasePrice:
                                                        data.purchasePrice
                                                          ? data.purchasePrice
                                                          : "",
                                                      stockQTY: data.noofStock
                                                        ? data.noofStock
                                                        : "--",
                                                      batchDetails:
                                                        data.batchDetails,
                                                      createdAt: data.createdAt,
                                                      createdBy: data.createdBy,
                                                      customFields:
                                                        data.customFields,
                                                      categoryId:
                                                        data.categoryId,
                                                      categoryName:
                                                        data.categoryName,
                                                      categoryNameValue:
                                                        data.categoryName,
                                                      taxPercentageId:
                                                        data.taxPercentageId !==
                                                          null ||
                                                        data.taxPercentageId !==
                                                          undefined
                                                          ? data.taxPercentageId
                                                          : "66f68f17cf8942d1531c55f4",
                                                      taxPercentageName:
                                                        data.taxPercentageName !==
                                                          null ||
                                                        data.taxPercentageName !==
                                                          undefined
                                                          ? data.taxPercentageName
                                                          : "0%",
                                                      // taxPercentageId:
                                                      //   data.taxPercentageId,
                                                      // taxPercentageName:
                                                      //   data.taxPercentageName,
                                                      taxPercentageValue:
                                                        data.taxPercentageValue,
                                                      serialMeasuringId:
                                                        data.serialMeasuringId,
                                                      serialMeasuringName:
                                                        data.serialMeasuringName,
                                                      image: data.image,
                                                      itemCodeValue:
                                                        data.itemCode,
                                                      salesPriceValue:
                                                        data.salesPrice,
                                                      purchasePriceValue:
                                                        data.purchasePrice &&
                                                        parseFloat(
                                                          data.purchasePrice
                                                        ).toFixed(2),
                                                      discountPrice:
                                                        !isUndefined(
                                                          data.discountPrice
                                                        )
                                                          ? data.discountPrice
                                                          : 0,
                                                      discountPercentage:
                                                        !isUndefined(
                                                          data.discountPercentage
                                                        )
                                                          ? data.discountPercentage
                                                          : 0,
                                                      taxPercentage:
                                                        data.taxPercentage,
                                                      taxValue:
                                                        totalSetAmountData,
                                                      totalAmount:
                                                        totalPrice &&
                                                        parseFloat(
                                                          totalPrice
                                                        ).toFixed(2),
                                                      quantityCount:
                                                        data.quantityCount
                                                          ? data.quantityCount
                                                          : 1,
                                                      categoryIdValue:
                                                        data.categoryId,
                                                      hsnCode: data.hsnCode,
                                                      descriptionValue:
                                                        data.description,
                                                      isProduct: data.isProduct,
                                                      isService: data.isService,
                                                      measuringId:
                                                        data.measuringId,
                                                      description:
                                                        data.description,
                                                      serialDetails:
                                                        data.serialDetails,
                                                      ramId: data.ramId,
                                                      ramName: data.ramName,
                                                      updatedAt: data.updatedAt,
                                                      status: data.status,
                                                    };
                                                  }
                                                )
                                              : [];

                                          const filteredData = Object.values(
                                            itemSelectedArrays.reduce(
                                              (acc, item) => {
                                                if (
                                                  !acc[item._id] ||
                                                  acc[item._id].quantityCount >
                                                    item.quantityCount
                                                ) {
                                                  acc[item._id] = item;
                                                }
                                                return acc;
                                              },
                                              {}
                                            )
                                          );
                                          setItemSelectedRows(filteredData);
                                          setPageRender(!pageRender);
                                        }}
                                        className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                      >
                                        <h1 className="text-[15px] purchase-label font-semibold">
                                          -
                                        </h1>
                                      </p>
                                      <h1 className="text-[14px] font-semibold purchase-label pt-1 pr-3 pl-3">
                                        {data.quantityCount}
                                      </h1>
                                      <p
                                        onClick={() => {
                                          data.quantityCount = parseInt(
                                            data.quantityCount + 1
                                          );

                                          let newSelecteds = [];
                                          if (data.quantityCount >= 1) {
                                            newSelecteds =
                                              data.quantityCount >= 1 &&
                                              newSelecteds.concat(
                                                itemSelectedRows,
                                                data
                                              );
                                            const itemSelectedFilteredRows =
                                              newSelecteds &&
                                              newSelecteds.length > 0
                                                ? newSelecteds.filter(
                                                    (data) =>
                                                      !isEmpty(data.itemName)
                                                  )
                                                : [];
                                            const itemSelectedArrays =
                                              newSelecteds &&
                                              itemSelectedFilteredRows &&
                                              itemSelectedFilteredRows.length >
                                                0
                                                ? itemSelectedFilteredRows.map(
                                                    (data, index) => {
                                                      const totalPriceData =
                                                        !isUndefined(
                                                          data.quantityCount
                                                        ) && data.purchasePrice
                                                          ? data.quantityCount *
                                                            data.purchasePrice
                                                          : isUndefined(
                                                              data.quantityCount
                                                            ) &&
                                                            data.purchasePrice
                                                          ? data.purchasePrice
                                                          : 0;
                                                      const totalSetAmountData =
                                                        data.taxPercentageValue
                                                          ? (totalPriceData *
                                                              data.taxPercentageValue) /
                                                            100
                                                          : data.taxPercentageName
                                                          ? parseFloat(
                                                              totalPriceData *
                                                                data.taxPercentageName
                                                            ) / 100
                                                          : 0;
                                                      const totalPrice =
                                                        totalSetAmountData +
                                                        totalPriceData;
                                                      return {
                                                        index: index + 1,
                                                        itemName: data.itemName,
                                                        itemNameValue:
                                                          data.itemName,
                                                        itemChecked:
                                                          data.quantityCount < 1
                                                            ? false
                                                            : true,
                                                        _id: data._id,
                                                        itemCode: data.itemCode
                                                          ? data.itemCode
                                                          : "--",
                                                        salesPrice:
                                                          data.salesPrice
                                                            ? data.salesPrice
                                                            : "",
                                                        purchasePrice:
                                                          data.purchasePrice
                                                            ? data.purchasePrice
                                                            : "",
                                                        stockQTY: data.noofStock
                                                          ? data.noofStock
                                                          : "--",
                                                        batchDetails:
                                                          data.batchDetails,
                                                        createdAt:
                                                          data.createdAt,
                                                        createdBy:
                                                          data.createdBy,
                                                        customFields:
                                                          data.customFields,
                                                        categoryId:
                                                          data.categoryId,
                                                        categoryName:
                                                          data.categoryName,
                                                        categoryNameValue:
                                                          data.categoryName,
                                                        taxPercentageId:
                                                          data.taxPercentageId !==
                                                            null ||
                                                          data.taxPercentageId !==
                                                            undefined
                                                            ? data.taxPercentageId
                                                            : "66f68f17cf8942d1531c55f4",
                                                        taxPercentageName:
                                                          data.taxPercentageName !==
                                                            null ||
                                                          data.taxPercentageName !==
                                                            undefined
                                                            ? data.taxPercentageName
                                                            : "0%",
                                                        // taxPercentageId:
                                                        //   data.taxPercentageId,
                                                        // taxPercentageName:
                                                        //   data.taxPercentageName,
                                                        taxPercentageValue:
                                                          data.taxPercentageValue,
                                                        serialMeasuringId:
                                                          data.serialMeasuringId,
                                                        serialMeasuringName:
                                                          data.serialMeasuringName,
                                                        image: data.image,
                                                        itemCodeValue:
                                                          data.itemCode,
                                                        salesPriceValue:
                                                          data.salesPrice,
                                                        ramId: data.ramId,
                                                        ramName: data.ramName,
                                                        purchasePriceValue:
                                                          data.purchasePrice &&
                                                          parseFloat(
                                                            data.purchasePrice
                                                          ).toFixed(2),
                                                        discountPrice:
                                                          !isUndefined(
                                                            data.discountPrice
                                                          )
                                                            ? data.discountPrice
                                                            : 0,
                                                        discountPercentage:
                                                          !isUndefined(
                                                            data.discountPercentage
                                                          )
                                                            ? data.discountPercentage
                                                            : 0,
                                                        taxPercentage:
                                                          data.taxPercentage,
                                                        taxValue:
                                                          totalSetAmountData,
                                                        totalAmount:
                                                          totalPrice &&
                                                          parseFloat(
                                                            totalPrice
                                                          ).toFixed(2),
                                                        quantityCount:
                                                          data.quantityCount
                                                            ? data.quantityCount
                                                            : 1,
                                                        categoryIdValue:
                                                          data.categoryId,
                                                        hsnCode: data.hsnCode,
                                                        descriptionValue:
                                                          data.description,
                                                        isProduct:
                                                          data.isProduct,
                                                        isService:
                                                          data.isService,
                                                        measuringId:
                                                          data.measuringId,
                                                        description:
                                                          data.description,
                                                        serialDetails:
                                                          data.serialDetails,
                                                        updatedAt:
                                                          data.updatedAt,
                                                        status: data.status,
                                                      };
                                                    }
                                                  )
                                                : [];
                                            const filteredData = Object.values(
                                              itemSelectedArrays.reduce(
                                                (acc, item) => {
                                                  if (
                                                    !acc[item._id] ||
                                                    acc[item._id]
                                                      .quantityCount <
                                                      item.quantityCount
                                                  ) {
                                                    acc[item._id] = item;
                                                  }
                                                  return acc;
                                                },
                                                {}
                                              )
                                            );
                                            setItemSelectedRows(filteredData);

                                            setPageRender(!pageRender);
                                          }
                                        }}
                                        className="pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                      >
                                        <h1 className="text-[15px] purchase-label font-semibold">
                                          +
                                        </h1>
                                      </p>
                                    </div>
                                    <div className="bg-[#f8f9fc] border border-r-0 border-y-0 border-l-2 p-1 pl-4 pr-4">
                                      <h1 className="pl-2">
                                        {data.quantityCount &&
                                          data.quantityCount}
                                      </h1>
                                    </div>
                                    {/* <PlusOutlined className="mr-1" /> Add */}
                                  </div>
                                  {/* ) : (
                                    <div
                                      onClick={() => {
                                        setQuantityShow(true);
                                      }}
                                      className="w-[100%] border-none bg-[#daedf3] text-[#1677ff]  text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                                    >
                                      <PlusOutlined className="mr-1" /> Add
                                    </div>
                                  )} */}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr key={0} className="table-purchase-orders-row">
                            <td colSpan={7} className="text-center">
                              No Data found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.1px",
              width: "104.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* Add Serial Numbers Modal */}
        <Modal
          open={quantityShow}
          title="Add Serial Numbers"
          onOk={() => setQuantityShow(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setQuantityShow(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-6px",
            }}
          />
          <Col span={24}>
            <Row>
              <Col span={24} className="pr-4 mb-2">
                <Typography className="purchase-label mb-2">
                  Item Name
                </Typography>
                <Typography className="purchase-label font-semibold text-[14px] mb-1">
                  Crab
                </Typography>
              </Col>
              <Col span={12} className="pr-4 mb-2">
                <Typography className="purchase-label mb-1">
                  {" "}
                  Quantity
                </Typography>

                <Input
                  name="serialOpenStock"
                  value={serialOpenStock}
                  onChange={(e) => setSerialOpenStock(e.target.value)}
                  suffix={
                    <div className="bg-[#e9e9e9] h-[38px] mr-[-5px] pr-[6px] pl-[6px]">
                      {" "}
                      <h1 className="mt-[-15px] h-[20px]">PCS</h1>
                    </div>
                  }
                  type="text"
                  className="item-stock"
                  placeholder=""
                />
              </Col>

              <Col span={24} className="pr-4 mb-2">
                <div>
                  <table className="table-purchase-serial table-responsive">
                    <thead>
                      <tr className="table-row">
                        <th className="table-head">IMEI/Serial No</th>
                        <th className="table-head">Date Created</th>
                        <th className="table-head"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {serialData.map((data, index) => {
                        return (
                          <tr key={index} className="">
                            <td className="table-data flex justify-between">
                              <Input
                                name="serialNo"
                                value={data.fieldName}
                                placeholder="Enter Custom Field name"
                                // className="w-[90%]"
                                onChange={(e) =>
                                  handleSerialDataChange(e, "serialNo", index)
                                }
                              />
                            </td>
                            <td className="table-data">
                              {moment().format("Do MMM YYYY")}{" "}
                            </td>
                            <td className="table-data">
                              {" "}
                              <DeleteOutlined
                                onClick={() => removeSerialData(index)}
                                type="primary"
                                className="ml-3 p-2 cursor-pointer"
                                size={"large"}
                              />{" "}
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="table-data">
                          <div
                            onClick={() => addSerialData()}
                            className="cursor-pointer text-[#1677ff]"
                          >
                            <PlusOutlined className="mr-2" />
                            Add New Serial No
                          </div>
                        </td>
                        <td className="table-data" colSpan={2}>
                          <div className="flex">
                            <BiQrScan className="mr-2 mt-1" />
                            <p>Scan Serial No</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "-8px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* New category modal */}
        <Modal
          open={itemCategoryModal}
          title={"Create Category"}
          onOk={() => {
            createCategory();
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isCategoryButtonDisabled ? true : false,
          }}
          width={450}
          onCancel={() => setItemCategoryModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "1px",
              width: "112%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mt-[-5px]">
            <Typography
              className="uppercase mb-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
            >
              Category Name
            </Typography>
            <Input
              name="categoryName"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              placeholder="Enter Category Name"
              className="p-2"
            />
            <p className="text-start text-[red] mt-2 mb-3">
              {categoryValidations && isEmpty(categoryName)
                ? "The category name field is required"
                : ""}
              {/* {simpleValidator.current.message(
                "categoryName",
                categoryName,
                "required"
              )} */}
            </p>
          </Col>
          {categoryAdditionalFields ? (
            <>
              {" "}
              <Col span={24} className="flex justify-end">
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => setCategoryAdditionalFields(false)}
                  className="cursor-pointer text-[#d54041] text-[13px]"
                >
                  Remove
                </div>
              </Col>
              <Col span={24}>
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Short Code
                </Typography>
                <Input
                  name="shortCode"
                  value={shortCode}
                  onChange={(e) => setShortCode(e.target.value)}
                  placeholder="Enter Short Code"
                  className="p-2"
                />
              </Col>
              <Col span={24} className="mb-[50px] mt-2">
                <Typography
                  className="uppercase mb-1"
                  style={{
                    fontFamily: "Poppins",
                    fontSize: "12px",
                  }}
                >
                  Description
                </Typography>
                <Input.TextArea
                  name="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter Description"
                  className="p-3"
                />
              </Col>
            </>
          ) : (
            <div
              style={{
                fontFamily: "Poppins",
              }}
              onClick={() => setCategoryAdditionalFields(true)}
              className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
            >
              <PlusOutlined className="mr-2" /> Additonal Fields
            </div>
          )}
        </Modal>

        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);

            history.push("/purchase-invoice");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
        {/* Purchase price Modal */}
        <Modal
          open={purchasePriceModal}
          title="Hide the Purchase price"
          onOk={() => {
            setPurchaseColumn(true);
            setPurchasePriceModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={() => setPurchasePriceModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              width: "110%",
              marginLeft: "-24px",
              marginTop: "-4px",
            }}
          />

          <Col span={24} className="mb-10">
            <div className="">
              <Typography className="text-center text-[14px] purchase-label">
                Are you sure you want to hide the
              </Typography>
              <Typography className="text-center ml-2  purchase-label font-semibold text-[14px]">
                purchase price in Invoice .?
              </Typography>
            </div>
          </Col>
        </Modal>

        <CreateItems
          routeName="PurchaseOrders"
          modalOpen={createItemModal}
          modalClose={handleClose}
        />
      </Row>

      {/* <Prompt
        when={!isEmpty(purchaseData) || !isEmpty(totalSectionData)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

CreatePurchaseInvoice.propTypes = {
  onSignin: PropTypes.any,
  location: PropTypes.any,
  recordsMetaData: PropTypes.any,
};

export default CreatePurchaseInvoice;
